<template>
  <div class="demo-container">
    <div class="go-top" @click="goToTop()">
      <v-icon>mdi-arrow-up</v-icon>
    </div>
    <div class="leave-demo-mode" @click="goTo('/')">{{ lang.demo.leave }}</div>
    <v-dialog v-model="notAllowedInDemoMode" persistent max-width="400px">
      <v-card>
        <v-card-title class="pb-0">
          <span class="gc-text-h6">{{ lang.demo.notAvailableTitle }}</span>
        </v-card-title>
        <v-card-text class="">
          {{ lang.demo.notAvailableText }}
        </v-card-text>
        <v-card-actions>
          <v-btn class="btn-bg" elevation="0" small @click="goTo('login')">
            {{ lang.actions.login }}
          </v-btn>
          <v-btn class="btn-bg" elevation="0" small @click="goTo('signup')">
            {{ lang.actions.signUp }}
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            elevation="0"
            small
            text
            @click="closeNotAllowedInDemoMode()"
          >
            {{ lang.actions.close }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="openDeleteCommentModel" max-width="400">
      <v-card class="px-4 pt-2 pb-4" v-if="commentForDelete">
        <div class="px-3 pt-3 mb-n3 d-flex justify-end">
          <v-icon class="cursor-pointer" @click="commentForDelete = null"
            >mdi-close</v-icon
          >
        </div>
        <div class="d-flex justify-center mb-4 mt-6">
          {{ lang.profile.w7 }}
          {{
            commentForDelete.type == "comment"
              ? lang.profile.comment
              : lang.profile.thread
          }}?
        </div>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            small
            text
            @click="closeDeleteCommentModel()"
            elevation="0"
          >
            {{ lang.actions.close }}
          </v-btn>
          <v-btn small class="btn-bg" elevation="0" @click="deleteComment()">
            {{ lang.actions.delete }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="showQrCodePopup" max-width="300">
      <v-card max-width="300" class="px-4 pt-2 pb-4">
        <div class="px-3 pt-3 mb-n3 d-flex justify-end">
          <v-icon class="cursor-pointer" @click="showQrCodePopup = false"
            >mdi-close</v-icon
          >
        </div>
        <div class="d-flex justify-center mb-4 mt-6">
          <qrcode-vue :size="200" :value="qrCodeValue"></qrcode-vue>
        </div>
        <div class="d-flex flex-column align-center">
          <p class="mb-0 pb-0 caption">{{ lang.profile.scanQrCodeFor }}</p>
          <h4 class="font-weight-bold">
            {{ `${personMetrics.deceasedFullName}` }}
          </h4>
        </div>
      </v-card>
    </v-dialog>
    <v-dialog v-model="showShareSocialActionsPopup" max-width="450">
      <v-card max-width="450" class="mx-auto">
        <div class="px-3 pt-3 mb-n3 d-flex justify-end">
          <v-icon
            class="cursor-pointer"
            @click="showShareSocialActionsPopup = false"
            >mdi-close</v-icon
          >
        </div>
        <div class="share-social-container">
          <ShareNetwork
            v-for="network in networks"
            :network="network.network"
            :key="network.network"
            :style="{ backgroundColor: network.color }"
            :url="sharing.url"
            :title="sharing.title"
            :description="sharing.description"
            :quote="sharing.quote"
            :hashtags="sharing.hashtags"
            :twitterUser="sharing.twitterUser"
          >
            <v-icon class="mr-1 white--text">{{ network.icon }}</v-icon>
            <span>{{ network.name }}</span>
          </ShareNetwork>
        </div>
      </v-card>
    </v-dialog>

    <LikesDialog :likeList="likeList" @closeLikeList="closeLikeList" />

    <v-dialog
      v-model="dialog"
      fullscreen
      hide-overlay
      transition="dialog-bottom-transition"
    >
      <v-card>
        <v-row class="no-gutters mt-0" v-if="currentPersonImage">
          <v-col class="col-12 col-md-9 image-container">
            <v-icon @click="closeImageDialog()" class="close-dialog"
              >mdi-close</v-icon
            >
            <div
              class="action-dialog d-flex flex-column align-center"
              v-if="
                personData &&
                personData.images &&
                personData.images[imageShowIndex]
              "
            >
              <div class="show-info-relative">
                <v-icon
                  @click="showInfoContainer(currentPersonImage, 'Image')"
                  class="mr-1 cursor-pointer display-1 mb-1 white--text"
                  >mdi-information-outline</v-icon
                >
                <div class="show-info-container" v-if="showInfo">
                  <v-card class="px-4 no-shadow">
                    <v-row class="mt-0" v-if="currentPersonImage">
                      <v-icon
                        v-if="
                          !showInfoEdit && personData.userId == currentUser.id
                        "
                        @click="editInfo(currentPersonImage, 'image')"
                        class="edit-dialog-info"
                        small
                        style="width: 20px; height: 20px"
                        >mdi-pencil</v-icon
                      >
                      <v-icon
                        small
                        style="width: 20px; height: 20px"
                        @click="closeInfoDialog()"
                        class="close-dialog-info"
                        >mdi-close</v-icon
                      >
                      <v-col cols="12" class="mt-10 px-1" v-if="showInfoEdit">
                        <v-text-field
                          v-model="info.location"
                          :label="lang.fields.location"
                          hide-details
                          outlined
                          dense
                          @keydown.enter="saveInfo(saveInfo)"
                        ></v-text-field>
                      </v-col>
                      <v-col cols="12" class="mt-10 px-1" v-else>
                        <p class="info-title body-2 font-weight-bold mb-0">
                          {{ lang.fields.location }}
                        </p>
                        <p class="info-text body-2 mb-0">
                          <v-icon class="caption">mdi-google-maps</v-icon>
                          {{
                            currentPersonImage.location || lang.profile.noData
                          }}
                        </p>
                        <v-divider class="mt-2"></v-divider>
                      </v-col>
                      <v-col cols="12" class="pt-0 px-1" v-if="showInfoEdit">
                        <v-text-field
                          v-model="info.title"
                          :label="lang.fields.title"
                          hide-details
                          outlined
                          dense
                          @keydown.enter="saveInfo(saveInfo)"
                        ></v-text-field>
                      </v-col>
                      <v-col cols="12" class="pt-0 px-1" v-else>
                        <p class="info-title body-2 font-weight-bold mb-0">
                          {{ lang.fields.title }}
                        </p>
                        <p class="info-text body-2 mb-0">
                          {{ currentPersonImage.title || lang.profile.noData }}
                        </p>
                        <v-divider class="mt-2"></v-divider>
                      </v-col>
                      <v-col cols="12" class="px-1" v-if="showInfoEdit">
                        <v-textarea
                          :label="lang.fields.description"
                          hide-details
                          no-resize
                          outlined
                          rows="4"
                          dense
                          @keydown.enter="saveInfo(saveInfo)"
                          v-model="info.description"
                        ></v-textarea>
                      </v-col>
                      <v-col cols="12" class="pt-0 px-1" v-else>
                        <p class="info-title body-2 font-weight-bold mb-0">
                          {{ lang.fields.description }}
                        </p>
                        <p class="info-text body-2 mb-0">
                          {{
                            currentPersonImage.description ||
                            lang.profile.noData
                          }}
                        </p>
                        <v-divider class="mt-2"></v-divider>
                      </v-col>
                      <v-col cols="12" class="px-1" v-if="showInfoEdit">
                        <v-menu
                          ref="dateOfEvent"
                          v-model="infoDateMenu"
                          :close-on-content-click="false"
                          transition="scale-transition"
                          offset-y
                          min-width="auto"
                        >
                          <template v-slot:activator="{ on, attrs }">
                            <v-text-field
                              v-model="info.memoryDate"
                              :label="lang.fields.date"
                              prepend-icon="mdi-calendar"
                              readonly
                              v-bind="attrs"
                              v-on="on"
                              outlined
                              dense
                            ></v-text-field>
                          </template>
                          <v-date-picker
                            v-model="info.memoryDate"
                            :active-picker.sync="activePickerInfo"
                            :max="
                              new Date(
                                Date.now() -
                                  new Date().getTimezoneOffset() * 60000
                              )
                                .toISOString()
                                .substr(0, 10)
                            "
                            min="1900-01-01"
                            @change="saveInfoDateMenu"
                          ></v-date-picker>
                        </v-menu>
                      </v-col>
                      <v-col cols="12" class="pt-0 px-1" v-else>
                        <p class="info-title body-2 font-weight-bold mb-0">
                          {{ lang.fields.date }}
                        </p>
                        <p class="info-text body-2 mb-0">
                          <v-icon class="caption mr-1">mdi-calendar</v-icon>
                          <span v-if="currentPersonImage.memoryDate">{{
                            currentPersonImage.memoryDate | shortFullDate
                          }}</span>
                          <span v-else>{{ lang.profile.noData }}</span>
                        </p>
                        <v-divider class="mt-2"></v-divider>
                      </v-col>
                      <v-col
                        v-if="showInfoEdit"
                        cols="12"
                        class="pt-0 mt-0 px-1"
                      >
                        <v-autocomplete
                          v-model="info.friends"
                          :disabled="isUpdating"
                          :items="people"
                          chips
                          outlined
                          color="primary"
                          :label="lang.fields.targeted"
                          item-text="name"
                          item-value="name"
                          multiple
                        >
                          <template v-slot:selection="data">
                            <v-chip
                              v-bind="data.attrs"
                              :input-value="data.selected"
                              close
                              @click="data.select"
                              @click:close="remove(data.item)"
                            >
                              <v-avatar left>
                                <v-img
                                  :src="data.item.avatar"
                                  :alt="data.item.name"
                                  :lazy-src="
                                    require('../../assets/images/lazy-loading.png')
                                  "
                                ></v-img>
                              </v-avatar>
                              {{ data.item.name }}
                            </v-chip>
                          </template>
                          <template v-slot:item="data">
                            <template v-if="isTypeOf(data)">
                              <v-list-item-content>{{
                                data.item
                              }}</v-list-item-content>
                            </template>
                            <template v-else>
                              <v-list-item-avatar>
                                <img
                                  :src="data.item.avatar"
                                  alt="Avatar of a person in Good Casper"
                                  :lazy-src="
                                    require('../../assets/images/lazy-loading.png')
                                  "
                                />
                              </v-list-item-avatar>
                              <v-list-item-content>
                                <v-list-item-title>{{
                                  data.item.name
                                }}</v-list-item-title>
                              </v-list-item-content>
                            </template>
                          </template>
                        </v-autocomplete>
                      </v-col>
                      <v-col cols="12" class="pt-0 px-1" v-else>
                        <p class="info-title body-2 mb-0 font-weight-bold">
                          {{ lang.fields.targeted }}
                        </p>
                        <div
                          v-if="
                            currentPersonImage.friends &&
                            currentPersonImage.friends.length
                          "
                        >
                          <v-chip
                            v-for="(el, index) in currentPersonImage.friends"
                            :key="'user' + index"
                            class="mr-1 mt-1"
                          >
                            {{ el }}
                          </v-chip>
                        </div>
                        <p v-else class="info-text body-2 mb-0">
                          {{ lang.profile.noData }}
                        </p>
                      </v-col>

                      <v-col
                        class="d-flex justify-end px-1"
                        v-if="showInfoEdit"
                      >
                        <v-btn
                          color="primary"
                          small
                          text
                          @click="closeEditInfoDialog()"
                          elevation="0"
                        >
                          {{ lang.actions.close }}
                        </v-btn>
                        <v-btn
                          small
                          class="btn-bg ml-2"
                          elevation="0"
                          @click="saveInfoDialog('image')"
                        >
                          {{ lang.actions.save }}
                        </v-btn>
                      </v-col>
                    </v-row>
                  </v-card>
                </div>
              </div>
              <v-icon
                :class="{
                  'red--text': entityLiked(currentPersonImage.likes),
                  'white--text': !entityLiked(currentPersonImage.likes),
                }"
                @click="
                  manageLike(
                    2,
                    currentPersonImage.likes,
                    currentPersonImage.id,
                    'image'
                  )
                "
                class="mr-1 cursor-pointer display-1"
                >mdi-heart</v-icon
              >
              <span
                class="text-underline cursor-pointer subtitle-1 mt-n2 text-shadow"
                @click="viewLikes(currentPersonImage.likes)"
                >{{ currentPersonImage.likes | shortCount }}</span
              >
              <v-icon
                @click="manageBookmark(currentPersonImage, 'Image')"
                :class="{
                  'orange--text': currentPersonImage.bookmarkedByLoggedInUser,
                  'white--text': !currentPersonImage.bookmarkedByLoggedInUser,
                }"
                class="mr-1 cursor-pointer display-1 mt-1"
                >mdi-bookmark</v-icon
              >
              <v-icon
                class="mr-1 cursor-pointer display-1 mt-1 white--text"
                @click="
                  shareContent(personData.images[imageShowIndex], 'image')
                "
                >mdi-share</v-icon
              >
              <v-icon
                class="mr-1 cursor-pointer title-2 mt-3 white--text show-mobile"
                @click="showComments('images')"
                >mdi-comment-multiple</v-icon
              >
            </div>
            <v-icon
              @click="leftImage()"
              class="back-image"
              v-if="imageShowIndex != 0"
              >mdi-chevron-left</v-icon
            >
            <v-icon
              v-if="
                personData.images &&
                imageShowIndex != personData.images.length - 1
              "
              @click="rightImage()"
              class="next-image"
              >mdi-chevron-right</v-icon
            >
            <div>
              <img
                :src="personData.images[imageShowIndex].imageUrl"
                alt="Person's image in Good Casper"
                :lazy-src="require('../../assets/images/lazy-loading.png')"
              />
            </div>
          </v-col>
          <v-col
            class="col-12 col-md-3 comment-container"
            :class="{ show: showComment }"
            v-if="
              (imageShowIndex != null || imageShowIndex == 0) && !threadList
            "
          >
            <div class="px-2 pt-6 comments">
              <div class="comment-x show-mobile">
                <v-icon @click="showComments('images')">mdi-close</v-icon>
              </div>
              <div
                v-if="
                  currentPersonImage &&
                  currentPersonImage.comments &&
                  currentPersonImage.comments.length
                "
              >
                <div
                  class="d-flex mb-3 comment-item"
                  v-for="(comment, index) in currentPersonImage.comments"
                  :key="index"
                >
                  <v-list-item-avatar size="33" class="py-0 my-0 ml-1 mr-3">
                    <v-img
                      class="user-profile-image py-0"
                      aspect-ratio="1"
                      :src="comment.imageUrl"
                      :alt="comment.fullName"
                      :lazy-src="
                        require('../../assets/images/lazy-loading.png')
                      "
                    ></v-img>
                  </v-list-item-avatar>
                  <div style="width: 100%">
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <p
                          class="font-weight-bold mt-0 mb-0 d-flex justify-space-between"
                        >
                          <span>{{ comment.fullName }}</span>
                          <span
                            v-bind="attrs"
                            v-on="on"
                            class="mt-n1 mb-2 caption-1 cursor-pointer"
                          >
                            {{ comment.createdAt | getFormattedDate }}
                          </span>
                        </p>
                      </template>
                      <span>{{ getDate(comment.createdAt) }}</span>
                    </v-tooltip>
                    <p
                      class="mb-2"
                      :id="'ddd' + index"
                      :class="{ 'green--text': editCommentId == comment.id }"
                    >
                      {{ comment.text }}
                      <v-icon
                        v-if="comment.userId == currentUser.id"
                        :class="{ 'green--text': editCommentId == comment.id }"
                        class="cursor-pointer subtitle-1 mx-2"
                        @click="editComment(comment)"
                        >mdi-pencil</v-icon
                      >
                      <v-icon
                        v-if="comment.userId == currentUser.id"
                        @click="
                          deleteCommentDialog(comment, 'comment', 'image')
                        "
                        class="subtitle-1 cursor-pointer"
                        >mdi-trash-can-outline</v-icon
                      >
                    </p>
                    <div class="d-flex justify-space-between">
                      <span class="caption"
                        ><v-icon
                          class="cursor-pointer"
                          :class="{
                            'red--text': entityLiked(comment.likes),
                            'gray--text': !entityLiked(comment.likes),
                          }"
                          @click="
                            manageLike(
                              3,
                              comment.likes,
                              comment.id,
                              'imageComment'
                            )
                          "
                          >mdi-heart</v-icon
                        >
                        <span
                          class="ml-2"
                          :class="{
                            'text-underline cursor-pointer': comment.likes,
                          }"
                          @click="viewLikes(comment.likes)"
                          >{{ comment.likes | shortCount }}</span
                        ></span
                      >
                      <span
                        class="caption cursor-pointer font-weight-bold grey--text text-underline"
                        @click="seeThreadsOverlay(comment)"
                        >{{ comment.thread.length | shortCount }}
                        {{ lang.profile.threadsExtra }}</span
                      >
                    </div>
                  </div>
                </div>
              </div>
              <div v-else class="pl-4">
                <h3>
                  <v-icon class="mr-2"
                    >mdi-comment-text-multiple-outline</v-icon
                  >
                  {{ lang.profile.noComments }}
                </h3>
              </div>
            </div>
            <div class="my-comment input-group pl-2 pr-0 d-flex">
              <textarea
                :placeholder="lang.fields.leaveAComment"
                rows="4"
                @keydown.enter="leaveCommentOnImage()"
                v-model="imageComment"
              ></textarea>
              <div
                class="d-flex flex-column justify-space-between align-center"
                style="height: 115px"
              >
                <v-list-item-avatar size="33" class="py-0 my-0 mr-1 ml-3">
                  <v-img
                    class="user-profile-image py-0"
                    aspect-ratio="1"
                    src="../../assets/images/demo/profile.png"
                    :alt="currentUser.name + ' ' + currentUser.lastName"
                    :lazy-src="require('../../assets/images/lazy-loading.png')"
                  ></v-img>
                </v-list-item-avatar>
                <v-icon
                  v-if="editCommentId"
                  class="ml-3 mr-1 cursor-pointer red--text"
                  @click="closeEditComment()"
                  >mdi-close</v-icon
                >
                <v-icon
                  class="ml-3 mr-1 cursor-pointer"
                  @click="leaveCommentOnImage()"
                  >mdi-send</v-icon
                >
              </div>
            </div>
          </v-col>
          <v-col
            class="col-12 col-md-3 comment-container"
            :class="{ show: showComment }"
            v-else
          >
            <div class="px-2 pt-4 comments" v-if="threadList">
              <div class="d-flex justify-space-between align-start">
                <p class="subtitle-2">{{ lang.profile.threads }}</p>
                <v-icon @click="closeThreadOverlay()">mdi-close</v-icon>
              </div>
              <div class="d-flex justify-space-between align-start">
                <div class="d-flex main-comment">
                  <v-list-item-avatar size="33" class="py-0 my-0 ml-1 mr-3">
                    <v-img
                      class="user-profile-image py-0"
                      aspect-ratio="1"
                      :src="threadList.imageUrl"
                      :alt="threadList.fullName"
                      :lazy-src="
                        require('../../assets/images/lazy-loading.png')
                      "
                    ></v-img>
                  </v-list-item-avatar>
                  <div style="width: 100%">
                    <p
                      class="font-weight-bold mt-0 mb-0 d-flex justify-space-between"
                    >
                      <span>{{ threadList.fullName }}</span>
                    </p>
                    <p class="mb-2">
                      {{ threadList.text }}
                    </p>
                  </div>
                </div>
              </div>
              <div
                v-if="
                  threadList && threadList.thread && threadList.thread.length
                "
              >
                <div
                  class="d-flex ml-2 mr-1 mb-4 comment-item"
                  v-for="(comment, index) in threadList.thread"
                  :key="index + 'thread'"
                >
                  <v-list-item-avatar size="33" class="py-0 my-0 ml-1 mr-3">
                    <v-img
                      class="user-profile-image py-0"
                      aspect-ratio="1"
                      :src="comment.imageUrl"
                      :alt="comment.fullName"
                      :lazy-src="
                        require('../../assets/images/lazy-loading.png')
                      "
                    ></v-img>
                  </v-list-item-avatar>
                  <div style="width: 100%">
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <p
                          class="font-weight-bold mt-0 mb-0 d-flex justify-space-between"
                        >
                          <span>{{ comment.fullName }}</span>
                          <span
                            v-bind="attrs"
                            v-on="on"
                            class="mt-n1 mb-2 caption-1 cursor-pointer"
                          >
                            {{ comment.createdAt | getFormattedDate }}
                          </span>
                        </p>
                      </template>
                      <span>{{ getDate(comment.createdAt) }}</span>
                    </v-tooltip>
                    <p
                      class="mb-2"
                      :id="'ddd' + index"
                      :class="{ 'green--text': editCommentId == comment.id }"
                    >
                      {{ comment.text }}
                      <v-icon
                        v-if="comment.userId == currentUser.id"
                        :class="{ 'green--text': editCommentId == comment.id }"
                        class="cursor-pointer subtitle-1 mx-2"
                        @click="editComment(comment)"
                        >mdi-pencil</v-icon
                      >
                      <v-icon
                        v-if="comment.userId == currentUser.id"
                        @click="deleteCommentDialog(comment, 'thread', 'image')"
                        class="subtitle-1 cursor-pointer"
                        >mdi-trash-can-outline</v-icon
                      >
                    </p>
                    <div class="d-flex justify-space-between">
                      <span class="caption"
                        ><v-icon
                          class="cursor-pointer"
                          :class="{
                            'red--text': entityLiked(comment.likes),
                            'gray--text': !entityLiked(comment.likes),
                          }"
                          @click="
                            manageLike(
                              3,
                              comment.likes,
                              comment.id,
                              'imageCommentThread',
                              comment
                            )
                          "
                          >mdi-heart</v-icon
                        >
                        <span
                          class="ml-2"
                          :class="{
                            'text-underline cursor-pointer': comment.likes,
                          }"
                          @click="viewLikes(comment.likes)"
                          >{{ comment.likes | shortCount }}</span
                        ></span
                      >
                    </div>
                  </div>
                </div>
              </div>
              <div v-else class="pl-4">
                <h4>
                  <v-icon class="mr-2"
                    >mdi-comment-text-multiple-outline</v-icon
                  >
                  {{ lang.profile.noThreads }}
                </h4>
              </div>
            </div>
            <div class="my-comment input-group pl-2 pr-0 d-flex">
              <textarea
                :placeholder="lang.fields.leaveAThread"
                rows="4"
                @keydown.enter="leaveCommentThreadOnImage()"
                v-model="imageCommentThread"
              ></textarea>
              <div
                class="d-flex flex-column justify-space-between align-center"
                style="height: 115px"
              >
                <v-list-item-avatar size="33" class="py-0 my-0 mr-1 ml-3">
                  <v-img
                    class="user-profile-image py-0"
                    aspect-ratio="1"
                    src="../../assets/images/demo/profile.png"
                    :alt="currentUser.name + ' ' + currentUser.lastName"
                    :lazy-src="require('../../assets/images/lazy-loading.png')"
                  ></v-img>
                </v-list-item-avatar>
                <v-icon
                  v-if="editCommentId"
                  class="ml-3 mr-1 cursor-pointer red--text"
                  @click="closeEditComment()"
                  >mdi-close</v-icon
                >
                <v-icon
                  class="ml-3 mr-1 cursor-pointer"
                  @click="leaveCommentThreadOnImage()"
                  >mdi-send</v-icon
                >
              </div>
            </div>
          </v-col>
        </v-row>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="dialogVideo"
      fullscreen
      hide-overlay
      transition="dialog-bottom-transition"
    >
      <v-card>
        <v-row class="no-gutters mx-0 my-0 mt-0" v-if="currentPersonVideo">
          <v-col class="col-12 col-md-9 image-container">
            <v-icon @click="closeVideoDialog()" class="close-dialog"
              >mdi-close</v-icon
            >
            <div
              class="action-dialog d-flex flex-column align-center"
              v-if="
                personData &&
                personData.videos &&
                personData.videos[videoShowIndex]
              "
            >
              <div class="show-info-relative">
                <v-icon
                  @click="showInfoContainer(currentPersonVideo, 'Video')"
                  class="mr-1 cursor-pointer display-1 mb-1 white--text"
                  >mdi-information-outline</v-icon
                >
                <div class="show-info-container" v-if="showInfo">
                  <v-card class="px-4 no-shadow">
                    <v-row class="mt-0" v-if="currentPersonVideo">
                      <v-icon
                        v-if="
                          !showInfoEdit && personData.userId == currentUser.id
                        "
                        @click="editInfo(currentPersonVideo, 'video')"
                        class="edit-dialog-info"
                        small
                        style="width: 20px; height: 20px"
                        >mdi-pencil</v-icon
                      >
                      <v-icon
                        small
                        style="width: 20px; height: 20px"
                        @click="closeInfoDialog()"
                        class="close-dialog-info"
                        >mdi-close</v-icon
                      >
                      <v-col cols="12" class="mt-10 px-1" v-if="showInfoEdit">
                        <v-text-field
                          v-model="info.location"
                          :label="lang.fields.location"
                          hide-details
                          outlined
                          dense
                          @keydown.enter="saveInfo(saveInfo)"
                        ></v-text-field>
                      </v-col>
                      <v-col cols="12" class="mt-10 px-1" v-else>
                        <p class="info-title body-2 font-weight-bold mb-0">
                          {{ lang.fields.location }}
                        </p>
                        <p class="info-text body-2 mb-0 px-1">
                          <v-icon class="caption">mdi-google-maps</v-icon>
                          {{
                            currentPersonVideo.location || lang.profile.noData
                          }}
                        </p>
                        <v-divider class="mt-2"></v-divider>
                      </v-col>
                      <v-col cols="12" class="pt-0 px-1" v-if="showInfoEdit">
                        <v-text-field
                          v-model="info.title"
                          :label="lang.fields.title"
                          hide-details
                          outlined
                          dense
                          @keydown.enter="saveInfo(saveInfo)"
                        ></v-text-field>
                      </v-col>
                      <v-col cols="12" class="pt-0 px-1" v-else>
                        <p class="info-title body-2 font-weight-bold mb-0">
                          {{ lang.fields.title }}
                        </p>
                        <p class="info-text body-2 mb-0">
                          {{ currentPersonVideo.title || lang.profile.noData }}
                        </p>
                        <v-divider class="mt-2"></v-divider>
                      </v-col>
                      <v-col cols="12" class="px-1" v-if="showInfoEdit">
                        <v-textarea
                          :label="lang.fields.description"
                          hide-details
                          no-resize
                          outlined
                          rows="4"
                          dense
                          @keydown.enter="saveInfo(saveInfo)"
                          v-model="info.description"
                        ></v-textarea>
                      </v-col>
                      <v-col cols="12" class="pt-0 px-1" v-else>
                        <p class="info-title body-2 font-weight-bold mb-0">
                          {{ lang.fields.description }}
                        </p>
                        <p class="info-text body-2 mb-0">
                          {{
                            currentPersonVideo.description ||
                            lang.profile.noData
                          }}
                        </p>
                        <v-divider class="mt-2"></v-divider>
                      </v-col>
                      <v-col cols="12" class="px-1" v-if="showInfoEdit">
                        <v-menu
                          ref="dateOfEvent"
                          v-model="infoDateMenu"
                          :close-on-content-click="false"
                          transition="scale-transition"
                          offset-y
                          min-width="auto"
                        >
                          <template v-slot:activator="{ on, attrs }">
                            <v-text-field
                              v-model="info.memoryDate"
                              :label="lang.fields.date"
                              prepend-icon="mdi-calendar"
                              readonly
                              v-bind="attrs"
                              v-on="on"
                              outlined
                              dense
                            ></v-text-field>
                          </template>
                          <v-date-picker
                            v-model="info.memoryDate"
                            :active-picker.sync="activePickerInfo"
                            :max="
                              new Date(
                                Date.now() -
                                  new Date().getTimezoneOffset() * 60000
                              )
                                .toISOString()
                                .substr(0, 10)
                            "
                            min="1900-01-01"
                            @change="saveInfoDateMenu"
                          ></v-date-picker>
                        </v-menu>
                      </v-col>
                      <v-col cols="12" class="pt-0 px-1" v-else>
                        <p class="info-title body-2 font-weight-bold mb-0">
                          {{ lang.fields.date }}
                        </p>
                        <p class="info-text body-2 mb-0">
                          <v-icon class="caption">mdi-calendar</v-icon>
                          <span v-if="currentPersonVideo.memoryDate">{{
                            currentPersonVideo.memoryDate | shortFullDate
                          }}</span>
                          <span v-else>{{ lang.profile.noData }}</span>
                        </p>
                        <v-divider class="mt-2"></v-divider>
                      </v-col>
                      <v-col
                        v-if="showInfoEdit"
                        cols="12"
                        class="pt-0 mt-0 px-1"
                      >
                        <v-autocomplete
                          v-model="info.friends"
                          :disabled="isUpdating"
                          :items="people"
                          chips
                          outlined
                          color="primary"
                          :label="lang.fields.targeted"
                          item-text="name"
                          item-value="name"
                          multiple
                        >
                          <template v-slot:selection="data">
                            <v-chip
                              v-bind="data.attrs"
                              :input-value="data.selected"
                              close
                              @click="data.select"
                              @click:close="remove(data.item)"
                            >
                              <v-avatar left>
                                <v-img
                                  :src="data.item.avatar"
                                  :alt="data.item.name"
                                  :lazy-src="
                                    require('../../assets/images/lazy-loading.png')
                                  "
                                ></v-img>
                              </v-avatar>
                              {{ data.item.name }}
                            </v-chip>
                          </template>
                          <template v-slot:item="data">
                            <template v-if="isTypeOf(data)">
                              <v-list-item-content>{{
                                data.item
                              }}</v-list-item-content>
                            </template>
                            <template v-else>
                              <v-list-item-avatar>
                                <img
                                  :src="data.item.avatar"
                                  alt="Avatar of a person in Good Casper"
                                  :lazy-src="
                                    require('../../assets/images/lazy-loading.png')
                                  "
                                />
                              </v-list-item-avatar>
                              <v-list-item-content>
                                <v-list-item-title>{{
                                  data.item.name
                                }}</v-list-item-title>
                              </v-list-item-content>
                            </template>
                          </template>
                        </v-autocomplete>
                      </v-col>
                      <v-col cols="12" class="pt-0 px-1" v-else>
                        <p class="info-title body-2 mb-0 font-weight-bold">
                          {{ lang.fields.targeted }}
                        </p>
                        <div
                          v-if="
                            currentPersonVideo.friends &&
                            currentPersonVideo.friends.length
                          "
                        >
                          <v-chip
                            v-for="(el, index) in currentPersonVideo.friends"
                            :key="'user' + index"
                            class="mr-1 mt-1"
                          >
                            {{ el }}
                          </v-chip>
                        </div>
                        <p v-else class="info-text body-2 mb-0">
                          {{ lang.profile.noData }}
                        </p>
                      </v-col>

                      <v-col
                        class="d-flex justify-end px-1"
                        v-if="showInfoEdit"
                      >
                        <v-btn
                          color="primary"
                          small
                          text
                          @click="closeEditInfoDialog()"
                          elevation="0"
                        >
                          {{ lang.actions.close }}
                        </v-btn>
                        <v-btn
                          small
                          class="btn-bg ml-2"
                          elevation="0"
                          @click="saveInfoDialog('video')"
                        >
                          {{ lang.actions.save }}
                        </v-btn>
                      </v-col>
                    </v-row>
                  </v-card>
                </div>
              </div>
              <v-icon
                :class="{
                  'red--text': entityLiked(currentPersonVideo.likes),
                  'white--text': !entityLiked(currentPersonVideo.likes),
                }"
                @click="
                  manageLike(
                    1,
                    currentPersonVideo.likes,
                    currentPersonVideo.id,
                    'video'
                  )
                "
                class="mr-1 cursor-pointer display-1"
                >mdi-heart</v-icon
              >
              <span
                class="text-underline cursor-pointer subtitle-1 mt-n2 text-shadow"
                @click="viewLikes(currentPersonVideo.likes)"
                >{{ currentPersonVideo.likes | shortCount }}</span
              >
              <v-icon
                @click="manageBookmark(currentPersonVideo, 'Video')"
                :class="{
                  'orange--text': currentPersonVideo.bookmarkedByLoggedInUser,
                  'white--text': !currentPersonVideo.bookmarkedByLoggedInUser,
                }"
                class="mr-1 cursor-pointer display-1 mt-1"
                >mdi-bookmark</v-icon
              >
              <v-icon
                class="mr-1 cursor-pointer display-1 mt-1 white--text"
                @click="
                  shareContent(personData.videos[videoShowIndex], 'video')
                "
                >mdi-share</v-icon
              >
              <v-icon
                class="mr-1 cursor-pointer title-2 mt-3 white--text show-mobile"
                @click="showComments('videos')"
                >mdi-comment-multiple</v-icon
              >
            </div>
            <v-icon
              @click="leftVideo()"
              class="back-image"
              v-if="videoShowIndex != 0"
              >mdi-chevron-left</v-icon
            >
            <v-icon
              v-if="
                personData.videos &&
                videoShowIndex != personData.videos.length - 1
              "
              @click="rightVideo()"
              class="next-image"
              >mdi-chevron-right</v-icon
            >
            <div class="d-flex justify-center">
              <video
                controls
                style="width: 100%"
                :key="currentPersonVideoUrl"
                v-if="currentPersonVideoUrl"
                controlsList="nodownload"
              >
                <source :src="currentPersonVideoUrl" type="video/mp4" />
                <source :src="currentPersonVideoUrl" type="video/webm" />
                <source :src="currentPersonVideoUrl" type="video/ogg" />
                <source :src="currentPersonVideoUrl" type="video/quicktime" />
                <source :src="currentPersonVideoUrl" type="video/x-msvideo" />
                <source :src="currentPersonVideoUrl" type="video/x-matroska" />
                Your browser does not support the video tag.
              </video>
            </div>
          </v-col>
          <v-col
            class="col-12 col-md-3 comment-container"
            :class="{ show: showComment }"
            v-if="
              (videoShowIndex != null || videoShowIndex == 0) && !threadList
            "
          >
            <div class="px-2 pt-6 comments">
              <div class="comment-x show-mobile">
                <v-icon @click="showComments('images')">mdi-close</v-icon>
              </div>
              <div
                v-if="
                  currentPersonVideo &&
                  currentPersonVideo.comments &&
                  currentPersonVideo.comments.length
                "
              >
                <div
                  class="d-flex mb-4 comment-item"
                  v-for="(comment, index) in currentPersonVideo.comments"
                  :key="index"
                >
                  <v-list-item-avatar size="33" class="py-0 my-0 ml-1 mr-3">
                    <v-img
                      class="user-profile-image py-0"
                      aspect-ratio="1"
                      src="../../assets/images/demo/profile.png"
                      :alt="currentUser.name + ' ' + currentUser.lastName"
                      :lazy-src="
                        require('../../assets/images/lazy-loading.png')
                      "
                    ></v-img>
                  </v-list-item-avatar>
                  <div style="width: 100%">
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <p
                          class="font-weight-bold mt-0 mb-0 d-flex justify-space-between"
                        >
                          <span>{{ comment.fullName }}</span>
                          <span
                            v-bind="attrs"
                            v-on="on"
                            class="mt-n1 mb-2 caption-1 cursor-pointer"
                          >
                            {{ comment.createdAt | getFormattedDate }}
                          </span>
                        </p>
                      </template>
                      <span>{{ getDate(comment.createdAt) }}</span>
                    </v-tooltip>
                    <p
                      class="mb-0"
                      :id="'ddd' + index"
                      :class="{ 'green--text': editCommentId == comment.id }"
                    >
                      {{ comment.text }}
                      <v-icon
                        v-if="comment.userId == currentUser.id"
                        :class="{ 'green--text': editCommentId == comment.id }"
                        class="cursor-pointer subtitle-1 mx-2"
                        @click="editComment(comment)"
                        >mdi-pencil</v-icon
                      >
                      <v-icon
                        v-if="comment.userId == currentUser.id"
                        @click="
                          deleteCommentDialog(comment, 'comment', 'video')
                        "
                        class="subtitle-1 cursor-pointer"
                        >mdi-trash-can-outline</v-icon
                      >
                    </p>
                    <div class="d-flex justify-space-between">
                      <span class="caption"
                        ><v-icon
                          class="cursor-pointer"
                          :class="{
                            'red--text': entityLiked(comment.likes),
                            'gray--text': !entityLiked(comment.likes),
                          }"
                          @click="
                            manageLike(
                              3,
                              comment.likes,
                              comment.id,
                              'videoComment'
                            )
                          "
                          >mdi-heart</v-icon
                        >
                        <span
                          class="ml-2"
                          :class="{
                            'text-underline cursor-pointer': comment.likes,
                          }"
                          @click="viewLikes(comment.likes)"
                          >{{ comment.likes | shortCount }}</span
                        >
                      </span>
                      <span
                        class="caption cursor-pointer font-weight-bold grey--text text-underline"
                        @click="seeThreadsOverlay(comment)"
                        >{{ comment.thread.length | shortCount }}
                        {{ lang.profile.threadsExtra }}</span
                      >
                    </div>
                  </div>
                </div>
              </div>
              <div v-else class="pl-4">
                <h4>
                  <v-icon class="mr-2"
                    >mdi-comment-text-multiple-outline</v-icon
                  >
                  {{ lang.profile.noComments }}
                </h4>
              </div>
            </div>
            <div class="my-comment input-group pl-2 pr-0 d-flex">
              <textarea
                :placeholder="lang.fields.leaveAComment"
                rows="4"
                @keydown.enter="leaveCommentOnVideo()"
                v-model="videoComment"
              ></textarea>
              <div
                class="d-flex flex-column justify-space-between align-center"
                style="height: 115px"
              >
                <v-list-item-avatar size="33" class="py-0 my-0 mr-1 ml-3">
                  <v-img
                    class="user-profile-image py-0"
                    aspect-ratio="1"
                    src="../../assets/images/demo/profile.png"
                    :alt="currentUser.name + ' ' + currentUser.lastName"
                    :lazy-src="require('../../assets/images/lazy-loading.png')"
                  ></v-img>
                </v-list-item-avatar>
                <v-icon
                  v-if="editCommentId"
                  class="ml-3 mr-1 cursor-pointer red--text"
                  @click="closeEditComment()"
                  >mdi-close</v-icon
                >
                <v-icon
                  class="ml-3 mr-1 cursor-pointer"
                  @click="leaveCommentOnVideo()"
                  >mdi-send</v-icon
                >
              </div>
            </div>
          </v-col>

          <v-col
            class="col-12 col-md-3 comment-container"
            :class="{ show: showComment }"
            v-else
          >
            <div class="px-2 pt-4 comments" v-if="threadList">
              <div class="d-flex justify-space-between align-start">
                <p class="subtitle-2">{{ lang.profile.threads }}</p>
                <v-icon @click="closeThreadOverlay()">mdi-close</v-icon>
              </div>
              <div class="d-flex justify-space-between align-start">
                <div class="d-flex main-comment">
                  <v-list-item-avatar size="33" class="py-0 my-0 ml-1 mr-3">
                    <v-img
                      class="user-profile-image py-0"
                      aspect-ratio="1"
                      src="../../assets/images/demo/profile.png"
                      :alt="threadList.fullName"
                      :lazy-src="
                        require('../../assets/images/lazy-loading.png')
                      "
                    ></v-img>
                  </v-list-item-avatar>
                  <div style="width: 100%">
                    <p
                      class="font-weight-bold mt-0 mb-0 d-flex justify-space-between"
                    >
                      <span>{{ threadList.fullName }}</span>
                    </p>
                    <p class="mb-2">
                      {{ threadList.text }}
                    </p>
                  </div>
                </div>
              </div>
              <div
                v-if="
                  threadList && threadList.thread && threadList.thread.length
                "
              >
                <div
                  class="d-flex ml-2 mr-1 mb-4 comment-item"
                  v-for="(comment, index) in threadList.thread"
                  :key="index + 'thread'"
                >
                  <v-list-item-avatar size="33" class="py-0 my-0 ml-1 mr-3">
                    <v-img
                      class="user-profile-image py-0"
                      aspect-ratio="1"
                      src="../../assets/images/demo/profile.png"
                      :alt="comment.fullName"
                      :lazy-src="
                        require('../../assets/images/lazy-loading.png')
                      "
                    ></v-img>
                  </v-list-item-avatar>
                  <div style="width: 100%">
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <p
                          class="font-weight-bold mt-0 mb-0 d-flex justify-space-between"
                        >
                          <span>{{ comment.fullName }}</span>
                          <span
                            v-bind="attrs"
                            v-on="on"
                            class="mt-n1 mb-2 caption-1 cursor-pointer"
                          >
                            {{ comment.createdAt | getFormattedDate }}
                          </span>
                        </p>
                      </template>
                      <span>{{ getDate(comment.createdAt) }}</span>
                    </v-tooltip>
                    <p
                      class="mb-2"
                      :id="'ddd' + index"
                      :class="{ 'green--text': editCommentId == comment.id }"
                    >
                      {{ comment.text }}
                      <v-icon
                        v-if="comment.userId == currentUser.id"
                        :class="{ 'green--text': editCommentId == comment.id }"
                        class="cursor-pointer subtitle-1 mx-2"
                        @click="editComment(comment)"
                        >mdi-pencil</v-icon
                      >
                      <v-icon
                        v-if="comment.userId == currentUser.id"
                        @click="deleteCommentDialog(comment, 'thread', 'video')"
                        class="subtitle-1 cursor-pointer"
                        >mdi-trash-can-outline</v-icon
                      >
                    </p>
                    <div class="d-flex justify-space-between">
                      <span class="caption"
                        ><v-icon
                          class="cursor-pointer"
                          :class="{
                            'red--text': entityLiked(comment.likes),
                            'gray--text': !entityLiked(comment.likes),
                          }"
                          @click="
                            manageLike(
                              3,
                              comment.likes,
                              comment.id,
                              'videoCommentThread',
                              comment
                            )
                          "
                          >mdi-heart</v-icon
                        >
                        <span
                          class="ml-2"
                          :class="{
                            'text-underline cursor-pointer': comment.likes,
                          }"
                          @click="viewLikes(comment.likes)"
                          >{{ comment.likes | shortCount }}</span
                        ></span
                      >
                    </div>
                  </div>
                </div>
              </div>
              <div v-else class="pl-4">
                <h4>
                  <v-icon class="mr-2"
                    >mdi-comment-text-multiple-outline</v-icon
                  >
                  {{ lang.profile.noThreads }}
                </h4>
              </div>
            </div>
            <div class="my-comment input-group pl-2 pr-0 d-flex">
              <textarea
                :placeholder="lang.fields.leaveAThread"
                rows="4"
                @keydown.enter="leaveCommentThreadOnVideo()"
                v-model="videoCommentThread"
              ></textarea>
              <div
                class="d-flex flex-column justify-space-between align-center"
                style="height: 115px"
              >
                <v-list-item-avatar size="33" class="py-0 my-0 mr-1 ml-3">
                  <v-img
                    class="user-profile-image py-0"
                    aspect-ratio="1"
                    src="../../assets/images/demo/profile.png"
                    :alt="currentUser.name + ' ' + currentUser.lastName"
                    :lazy-src="require('../../assets/images/lazy-loading.png')"
                  ></v-img>
                </v-list-item-avatar>
                <v-icon
                  v-if="editCommentId"
                  class="ml-3 mr-1 cursor-pointer red--text"
                  @click="closeEditComment()"
                  >mdi-close</v-icon
                >
                <v-icon
                  class="ml-3 mr-1 cursor-pointer"
                  @click="leaveCommentThreadOnVideo()"
                  >mdi-send</v-icon
                >
              </div>
            </div>
          </v-col>
        </v-row>
      </v-card>
    </v-dialog>

    <FollowersDialog
      :followerList="followerList"
      @closeFollowerList="closeFollowerList"
      :dialogFollowers="dialogFollowers"
    />

    <div class="wrapper">
      <v-row class="pt-4">
        <v-col class="col-12 mb-n2 pb-0" v-if="showAlert">
          <v-alert
            :value="showAlert"
            dismissible
            border="left"
            elevation="0"
            class="mb-4"
            @input="showAlert = false"
          >
            <p class="font-weight-bold subtitle-1">
              {{ lang.demo.disclaimer }}
            </p>
            <p class="mb-0 subtitle-2">{{ lang.demo.disclaimerText }}</p>
          </v-alert>
        </v-col>
        <v-col class="col-12 col-md-4 col-lg-3 column-center">
          <v-card
            v-if="Object.keys(personMetrics).length === 0"
            style="
              width: 100%;
              box-shadow: 0 2px 12px rgba(0, 0, 0, 0.05) !important;
              border-radius: 12px;
            "
            elevation="0"
          >
            <v-skeleton-loader
              type="image, list-item-three-line, list-item-two-line, list-item-two-line, list-item-two-line"
            ></v-skeleton-loader>
          </v-card>
          <v-card
            elevation="0"
            style="
              width: 100%;
              box-shadow: 0 2px 12px rgba(0, 0, 0, 0.05) !important;
              border-radius: 12px;
            "
            v-else
          >
            <v-card-text class="column-center text-center">
              <v-btn
                class="edit-pen"
                text
                outlined
                v-if="personData.userId == currentUser.id && !editMode"
                icon
                color="primary"
                @click="setEditMode(true)"
              >
                <v-icon>mdi-pencil</v-icon>
              </v-btn>
              <v-btn
                class="share-social-profile"
                text
                outlined
                icon
                color="primary"
              >
                <v-icon @click="shareContent(personData, 'profile')"
                  >mdi-share</v-icon
                >
              </v-btn>
              <v-btn class="qr-code" text outlined icon color="primary">
                <v-icon @click="showQrCodePopup = true">mdi-qrcode-scan</v-icon>
              </v-btn>
              <div class="rel">
                <v-img
                  class="user-image"
                  aspect-ratio="1"
                  style="border-radius: 50%"
                  src="../../assets/images/demo/profile.png"
                  :alt="personMetrics.deceasedFullName"
                  :lazy-src="require('../../assets/images/lazy-loading.png')"
                ></v-img>
                <div
                  class="input-image-container border-primary"
                  @click="triggerFileUpload()"
                >
                  <div class="camera-container">
                    <v-icon>mdi-camera</v-icon>
                  </div>
                </div>
              </div>
              <p
                class="headline mt-4 font-weight-bold"
                :class="{
                  'mb-2': !personMetrics.nickname,
                  'mb-0': personMetrics.nickname,
                }"
              >
                {{ `${personMetrics.deceasedFullName || ""}` }}
              </p>
              <p
                class="caption mt-0 mb-2 font-weight-bold"
                v-if="personMetrics.nickname"
              >
                {{ `${personMetrics.nickname}` }}
              </p>
              <span class="caption">{{
                getBirthToDeathDate(
                  personMetrics.dateOfBirth,
                  personMetrics.dateOfDeath
                )
              }}</span>
              <div class="profile-stats profile-stats--user">
                <div class="text-center mb-2">
                  <p class="display-1 mb-0">
                    {{
                      getPersonAge(
                        personMetrics.dateOfBirth,
                        personMetrics.dateOfDeath
                      )
                    }}
                  </p>
                  <span class="overline">{{ lang.profile.age }}</span>
                </div>
                <div class="text-center mb-2">
                  <p class="display-1 mb-0">
                    {{ personMetrics.numberOfPictures }}
                  </p>
                  <span class="overline">{{ lang.profile.photos }}</span>
                </div>
                <div class="text-center mb-2">
                  <p class="display-1 mb-0">
                    {{ personMetrics.numberOfVideos }}
                  </p>
                  <span class="overline">{{ lang.profile.videos }}</span>
                </div>
                <div class="text-center mb-2">
                  <p class="display-1 mb-0">
                    {{ personMetrics.numberOfDocuments }}
                  </p>
                  <span class="overline">{{ lang.profile.documents }}</span>
                </div>
                <div
                  class="text-center mb-2 cursor-pointer"
                  @click="showFollowers()"
                >
                  <p class="display-1 mb-0 primary--text">
                    {{ followerList.length | shortCount }}
                  </p>
                  <span class="overline primary--text">{{
                    lang.profile.followers
                  }}</span>
                </div>
                <div class="text-center mb-2">
                  <p class="display-1 mb-0">
                    {{ personMetrics.numberOfLastGreetings }}
                  </p>
                  <span class="overline">{{ lang.profile.greetings }}</span>
                </div>
              </div>
            </v-card-text>
          </v-card>
        </v-col>
        <v-col class="col-12 col-md-8 col-lg-9">
          <v-card
            v-if="Object.keys(personData).length === 0"
            style="
              width: 100%;
              box-shadow: 0 2px 12px rgba(0, 0, 0, 0.05) !important;
              border-radius: 12px;
            "
            elevation="0"
          >
            <v-skeleton-loader
              type="article, article, article, table-heading"
            ></v-skeleton-loader>
          </v-card>
          <v-card
            elevation="0"
            style="
              box-shadow: 0 2px 12px rgba(0, 0, 0, 0.05) !important;
              border-radius: 12px;
            "
            v-else
          >
            <v-form ref="profileForm">
              <v-card-text
                class="pt-7 profile-stats"
                :class="{ 'edit-mode': editMode }"
              >
                <section class="mb-2">
                  <WeeklyTales
                    :weeklyTales="weeklyTalesItems"
                    @demoMode="notAllowedInDemoMode = true"
                  />
                </section>
                <div class="full-row px-0">
                  <v-expansion-panels class="mb-6">
                    <v-expansion-panel>
                      <v-expansion-panel-header
                        class="py-0"
                        @click="togglePanel = !togglePanel"
                      >
                        <span class="font-weight-bold subtitle-1">{{
                          lang.profile.general
                        }}</span>
                      </v-expansion-panel-header>
                      <v-expansion-panel-content>
                        <v-row class="mt-0 pb-4">
                          <v-row class="px-2">
                            <v-col cols="12">
                              <span class="title primary--text">{{
                                lang.addMemories.personalInfo
                              }}</span>
                            </v-col>
                            <v-col
                              v-if="personMetrics.isHuman"
                              cols="12"
                              sm="6"
                              md="3"
                              class="py-0"
                            >
                              <div>
                                <div class="mb-2" v-if="!editMode">
                                  <p class="mb-1">
                                    <span class="overline d-block mb-n2">{{
                                      lang.fields.occupation
                                    }}</span>
                                    {{ personData.occupation || "-" }}
                                  </p>
                                </div>
                              </div>
                            </v-col>

                            <v-col
                              cols="12"
                              sm="12"
                              :md="!editMode ? 3 : 6"
                              class="py-0"
                            >
                              <span
                                class="overline d-block mb-n2"
                                v-if="!editMode"
                                >{{ lang.fields.gender }}</span
                              >
                              <div v-if="!editMode">
                                <p class="mb-1">
                                  {{ personData.gender || "-" }}
                                </p>
                              </div>
                              <div v-else class="d-flex mt-n3">
                                <v-radio-group v-model="personData.gender" row>
                                  <v-radio
                                    :label="lang.fields.other"
                                    value="Other"
                                    :ripple="false"
                                  ></v-radio>
                                  <v-radio
                                    :label="lang.fields.male"
                                    value="Male"
                                    :ripple="false"
                                  ></v-radio>
                                  <v-radio
                                    :label="lang.fields.female"
                                    value="Female"
                                    :ripple="false"
                                  ></v-radio>
                                </v-radio-group>
                              </div>
                            </v-col>

                            <v-col
                              v-if="personMetrics.isHuman"
                              cols="12"
                              sm="6"
                              md="3"
                              class="py-0"
                            >
                              <div>
                                <div v-if="!editMode">
                                  <span class="overline d-block mb-n2">{{
                                    lang.fields.zodiacSign
                                  }}</span>
                                  <p class="mb-1">
                                    {{ personData.zodiacSign || "-" }}
                                  </p>
                                </div>
                              </div>
                            </v-col>

                            <v-col cols="12" sm="6" md="3" class="py-0">
                              <div v-if="!editMode">
                                <span class="overline d-block mb-n2">{{
                                  lang.fields.eyeColor
                                }}</span>
                                <p class="mb-1">
                                  {{ personData.eyeColor || "-" }}
                                </p>
                              </div>
                            </v-col>

                            <v-col cols="12" sm="6" md="3" class="py-0">
                              <div v-if="!editMode">
                                <span class="overline d-block mb-n2">{{
                                  lang.fields.height
                                }}</span>
                                <p class="mb-1">
                                  {{ personData.height || "-" }}
                                </p>
                              </div>
                            </v-col>

                            <v-col cols="12" sm="6" md="3" class="py-0">
                              <div v-if="!editMode">
                                <span class="overline d-block mb-n2">{{
                                  lang.fields.weight
                                }}</span>
                                <p class="mb-1">
                                  {{ personData.weight || "-" }}
                                </p>
                              </div>
                            </v-col>

                            <v-col cols="12">
                              <span class="title primary--text">{{
                                lang.fields.location
                              }}</span>
                            </v-col>

                            <v-col cols="12" sm="6" md="3" class="py-0">
                              <div v-if="!editMode">
                                <span class="overline d-block mb-n2">{{
                                  lang.fields.country
                                }}</span>
                                <p class="mb-1">
                                  {{ personData.country || "-" }}
                                </p>
                              </div>
                            </v-col>

                            <v-col cols="12" sm="6" md="3" class="py-0">
                              <div v-if="!editMode">
                                <span class="overline d-block mb-n2">{{
                                  lang.fields.city
                                }}</span>
                                <p class="mb-1">
                                  {{ personData.city || "-" }}
                                </p>
                              </div>
                            </v-col>

                            <v-col cols="12">
                              <span class="title primary--text">{{
                                lang.addMemories.graveInfo
                              }}</span>
                            </v-col>

                            <v-col class="col-12 pt-0" v-if="!editMode">
                              <div
                                id="map"
                                style="height: 300px; margin-top: 16px"
                              ></div>
                            </v-col>

                            <v-col cols="12" sm="6" md="3" class="py-0">
                              <div v-if="!editMode">
                                <span class="overline d-block mb-n2">{{
                                  lang.fields.graveCountry
                                }}</span>
                                <p class="mb-1">
                                  {{ personData.graveLocationCountry || "-" }}
                                </p>
                              </div>
                            </v-col>

                            <v-col cols="12" sm="6" md="3" class="py-0">
                              <div v-if="!editMode">
                                <span class="overline d-block mb-n2">{{
                                  lang.fields.graveCity
                                }}</span>
                                <p class="mb-1">
                                  {{ personData.graveLocationCity || "-" }}
                                </p>
                              </div>
                            </v-col>

                            <v-col cols="12" sm="6" md="6" class="py-0">
                              <div v-if="!editMode">
                                <span class="overline d-block mb-n2">{{
                                  lang.fields.graveDescription
                                }}</span>
                                <p class="mb-1">
                                  {{
                                    personData.graveLocationDescription || "-"
                                  }}
                                </p>
                              </div>
                            </v-col>
                          </v-row>
                        </v-row>
                      </v-expansion-panel-content>
                    </v-expansion-panel>
                  </v-expansion-panels>
                </div>
                <div class="full-row px-0">
                  <v-expansion-panels class="mb-4">
                    <v-expansion-panel>
                      <v-expansion-panel-header class="py-0">
                        <span class="font-weight-bold subtitle-1">{{
                          lang.profile.favorites
                        }}</span>
                      </v-expansion-panel-header>
                      <v-expansion-panel-content>
                        <v-row class="mt-0 pb-4" v-if="personMetrics.isHuman">
                          <v-row class="px-2">
                            <v-col cols="12">
                              <span class="title primary--text">{{
                                lang.addMemories.food
                              }}</span>
                            </v-col>
                            <v-col
                              cols="12"
                              sm="6"
                              md="3"
                              :class="{ 'pb-0': !editMode }"
                              v-for="favorite in foodArray"
                              :key="favorite.type"
                            >
                              <div class="text-left mb-0" v-if="!editMode">
                                <span class="overline d-block mb-n2">{{
                                  lang.fields[favorite.type]
                                }}</span>
                                <v-tooltip bottom>
                                  <template v-slot:activator="{ on, attrs }">
                                    <p v-bind="attrs" v-on="on" class="mb-0">
                                      {{ favorite.value || "-" }}
                                    </p>
                                  </template>
                                  <span>{{ favorite.value || "-" }}</span>
                                </v-tooltip>
                              </div>
                            </v-col>
                          </v-row>
                          <v-row class="px-2 pb-4 pt-5">
                            <v-col cols="12">
                              <span class="title primary--text">{{
                                lang.addMemories.drinks
                              }}</span>
                            </v-col>
                            <v-col
                              cols="12"
                              sm="6"
                              md="3"
                              :class="{ 'pb-0': !editMode }"
                              v-for="favorite in drinkArray"
                              :key="favorite.type"
                            >
                              <div class="text-left mb-0" v-if="!editMode">
                                <span class="overline d-block mb-n2">{{
                                  lang.fields[favorite.type]
                                }}</span>
                                <v-tooltip bottom>
                                  <template v-slot:activator="{ on, attrs }">
                                    <p v-bind="attrs" v-on="on" class="mb-0">
                                      {{ favorite.value || "-" }}
                                    </p>
                                  </template>
                                  <span>{{ favorite.value || "-" }}</span>
                                </v-tooltip>
                              </div>
                            </v-col>
                          </v-row>
                          <v-row class="px-2 pb-4 pt-5">
                            <v-col cols="12">
                              <span class="title primary--text">{{
                                lang.addMemories.movies
                              }}</span>
                            </v-col>
                            <v-col
                              cols="12"
                              sm="6"
                              md="3"
                              :class="{ 'pb-0': !editMode }"
                              v-for="favorite in movieArray"
                              :key="favorite.type"
                            >
                              <div class="text-left mb-0" v-if="!editMode">
                                <span class="overline d-block mb-n2">{{
                                  lang.fields[favorite.type]
                                }}</span>
                                <v-tooltip bottom>
                                  <template v-slot:activator="{ on, attrs }">
                                    <p v-bind="attrs" v-on="on" class="mb-0">
                                      {{ favorite.value || "-" }}
                                    </p>
                                  </template>
                                  <span>{{ favorite.value || "-" }}</span>
                                </v-tooltip>
                              </div>
                            </v-col>
                          </v-row>
                          <v-row class="px-2 pb-4 pt-5">
                            <v-col cols="12">
                              <span class="title primary--text">{{
                                lang.addMemories.musics
                              }}</span>
                            </v-col>
                            <v-col
                              cols="12"
                              sm="6"
                              md="3"
                              :class="{ 'pb-0': !editMode }"
                              v-for="favorite in musicArray"
                              :key="favorite.type"
                            >
                              <div class="text-left mb-0" v-if="!editMode">
                                <span class="overline d-block mb-n2">{{
                                  lang.fields[favorite.type]
                                }}</span>
                                <v-tooltip bottom>
                                  <template v-slot:activator="{ on, attrs }">
                                    <p v-bind="attrs" v-on="on" class="mb-0">
                                      {{ favorite.value || "-" }}
                                    </p>
                                  </template>
                                  <span>{{ favorite.value || "-" }}</span>
                                </v-tooltip>
                              </div>
                            </v-col>
                          </v-row>
                          <v-row class="px-2 pb-4 pt-5" style="width: 100%">
                            <v-col cols="12">
                              <span class="title primary--text">{{
                                lang.addMemories.books
                              }}</span>
                            </v-col>
                            <v-col
                              cols="12"
                              sm="6"
                              md="3"
                              :class="{ 'pb-0': !editMode }"
                              v-for="favorite in booksArray"
                              :key="favorite.type"
                            >
                              <div class="text-left mb-0" v-if="!editMode">
                                <span class="overline d-block mb-n2">{{
                                  lang.fields[favorite.type]
                                }}</span>
                                <v-tooltip bottom>
                                  <template v-slot:activator="{ on, attrs }">
                                    <p v-bind="attrs" v-on="on" class="mb-0">
                                      {{ favorite.value || "-" }}
                                    </p>
                                  </template>
                                  <span>{{ favorite.value || "-" }}</span>
                                </v-tooltip>
                              </div>
                              <div v-else>
                                <v-text-field
                                  v-model="favorite.value"
                                  :label="lang.fields[favorite.type]"
                                  outlined
                                  hide-details
                                  dense
                                ></v-text-field>
                              </div>
                            </v-col>
                          </v-row>
                          <v-row class="px-2 pb-4 pt-5" style="width: 100%">
                            <v-col cols="12">
                              <span class="title primary--text">{{
                                lang.addMemories.sports
                              }}</span>
                            </v-col>
                            <v-col
                              cols="12"
                              sm="6"
                              md="3"
                              :class="{ 'pb-0': !editMode }"
                              v-for="favorite in sportArray"
                              :key="favorite.type"
                            >
                              <div class="text-left mb-0" v-if="!editMode">
                                <span class="overline d-block mb-n2">{{
                                  lang.fields[favorite.type]
                                }}</span>
                                <v-tooltip bottom>
                                  <template v-slot:activator="{ on, attrs }">
                                    <p v-bind="attrs" v-on="on" class="mb-0">
                                      {{ favorite.value || "-" }}
                                    </p>
                                  </template>
                                  <span>{{ favorite.value || "-" }}</span>
                                </v-tooltip>
                              </div>
                            </v-col>
                          </v-row>
                          <v-row class="px-2 pb-4 pt-5">
                            <v-col cols="12">
                              <span class="title primary--text">{{
                                lang.addMemories.lifestyle
                              }}</span>
                            </v-col>
                            <v-col
                              cols="12"
                              sm="6"
                              md="3"
                              :class="{ 'pb-0': !editMode }"
                              v-for="favorite in lifestyleArray"
                              :key="favorite.type"
                            >
                              <div class="text-left mb-0" v-if="!editMode">
                                <span class="overline d-block mb-n2">{{
                                  lang.fields[favorite.type]
                                }}</span>
                                <v-tooltip bottom>
                                  <template v-slot:activator="{ on, attrs }">
                                    <p v-bind="attrs" v-on="on" class="mb-0">
                                      {{ favorite.value || "-" }}
                                    </p>
                                  </template>
                                  <span>{{ favorite.value || "-" }}</span>
                                </v-tooltip>
                              </div>
                              <div v-else>
                                <v-text-field
                                  v-model="favorite.value"
                                  :label="lang.fields[favorite.type]"
                                  outlined
                                  hide-details
                                  dense
                                ></v-text-field>
                              </div>
                            </v-col>
                          </v-row>
                          <v-row class="px-2 pb-4 pt-5">
                            <v-col cols="12">
                              <span class="title primary--text">{{
                                lang.addMemories.travel
                              }}</span>
                            </v-col>
                            <v-col
                              cols="12"
                              sm="6"
                              md="3"
                              :class="{ 'pb-0': !editMode }"
                              v-for="favorite in travelArray"
                              :key="favorite.type"
                            >
                              <div class="text-left mb-0" v-if="!editMode">
                                <span class="overline d-block mb-n2">{{
                                  lang.fields[favorite.type]
                                }}</span>
                                <v-tooltip bottom>
                                  <template v-slot:activator="{ on, attrs }">
                                    <p v-bind="attrs" v-on="on" class="mb-0">
                                      {{ favorite.value || "-" }}
                                    </p>
                                  </template>
                                  <span>{{ favorite.value || "-" }}</span>
                                </v-tooltip>
                              </div>
                            </v-col>
                          </v-row>
                        </v-row>
                      </v-expansion-panel-content>
                    </v-expansion-panel>
                  </v-expansion-panels>
                </div>
                <div class="d-flex justify-end action-form" v-if="editMode">
                  <v-btn
                    class="primary--text"
                    text
                    @click="cancelEditMode()"
                    small
                    elevation="0"
                    >{{ lang.actions.cancel }}</v-btn
                  >
                  <v-btn
                    class="ml-2 btn-bg"
                    @click="updateProfile()"
                    small
                    elevation="0"
                    >{{ lang.actions.save }}</v-btn
                  >
                </div>
              </v-card-text>
            </v-form>
          </v-card>
        </v-col>
      </v-row>
      <v-row class="mb-0">
        <v-col class="col-12">
          <v-tabs
            v-model="tabSelected"
            right
            style="
              box-shadow: 0 2px 12px rgba(0, 0, 0, 0.05) !important;
              border-top-left-radius: 12px;
              border-top-left-radius: 12px;
            "
          >
            <v-tab>
              <v-icon class="mr-2">mdi-human-greeting</v-icon>
              <span class="hide-on-mobile">{{
                lang.profile.lastGreetings
              }}</span></v-tab
            >
            <v-tab
              ><v-icon class="mr-2">mdi-timeline-text</v-icon
              ><span class="hide-on-mobile">{{
                lang.profile.biography
              }}</span></v-tab
            >
            <v-tab
              ><v-icon class="mr-2">mdi-image</v-icon
              ><span class="hide-on-mobile">{{
                lang.profile.photos
              }}</span></v-tab
            >
            <v-tab
              ><v-icon class="mr-2">mdi-video</v-icon
              ><span class="hide-on-mobile">{{
                lang.profile.videos
              }}</span></v-tab
            >
            <v-tab
              ><v-icon class="mr-2">mdi-file-document</v-icon
              ><span class="hide-on-mobile">{{
                lang.profile.documents
              }}</span></v-tab
            >
            <v-tab>
              <v-icon class="mr-2">mdi-puzzle</v-icon>
              <span class="hide-on-mobile">{{
                lang.profile.missingPuzzle
              }}</span
              ><span class="suggestions-count">4</span></v-tab
            >
          </v-tabs>
          <v-skeleton-loader
            v-if="Object.keys(personData).length === 0"
            type="list-item-avatar-three-line, list-item-avatar-three-line, list-item-avatar-three-line, list-item-avatar-three-line, list-item-avatar-three-line"
          ></v-skeleton-loader>
          <v-tabs-items
            v-else
            v-model="tabSelected"
            class="pt-8"
            style="
              box-shadow: 0 2px 12px rgba(0, 0, 0, 0.05) !important;
              border-bottom-left-radius: 12px;
              border-bottom-right-radius: 12px;
            "
          >
            <v-tab-item>
              <div v-if="lastGreetingsLoading">
                <v-skeleton-loader
                  type="list-item-avatar-three-line, list-item-avatar-three-line, list-item-avatar-three-line, list-item-avatar-three-line, list-item-avatar-three-line"
                ></v-skeleton-loader>
              </div>
              <div v-else-if="lastGreetings.length">
                <LastGreeting
                  :currentUser="currentUser"
                  :personData="personData"
                  @deleteLastGreetingModal="deleteLastGreetingModal"
                  @editLastGreetingModal="addLastGreetingModal"
                  v-for="(lastGreeting, index) in lastGreetings"
                  :key="index"
                  :lastGreeting="lastGreeting"
                />
              </div>
              <NoResult
                v-else
                class="mt-0"
                :show="true"
                :title="lang.response.w1"
              ></NoResult>
            </v-tab-item>
            <v-tab-item>
              <Biography
                v-if="!loadingBiographies"
                :currentUser="currentUser"
                :personData="personData"
                :biographies="biographies"
                @editTimeline="editTimeline"
                @addTimeline="addTimeline"
                @deleteTimeline="deleteTimeline"
              ></Biography>
              <v-skeleton-loader
                v-else
                type="list-item-avatar-three-line, list-item-avatar-three-line, list-item-avatar-three-line, list-item-avatar-three-line, list-item-avatar-three-line"
              ></v-skeleton-loader>
            </v-tab-item>
            <v-tab-item>
              <Photos
                @emitDeleteImage="deleteImage"
                @emitImageShow="emitImageShow"
                :images="personData.images"
              ></Photos>
              <v-pagination
                class="my-4"
                v-model="imagesPage"
                :length="7"
                :total-visible="5"
                prev-icon="mdi-menu-left"
                next-icon="mdi-menu-right"
                @input="
                  notAllowedInDemoMode = true;
                  imagesPage = 1;
                "
              ></v-pagination>
            </v-tab-item>
            <v-tab-item>
              <Videos
                @emitDeleteVideo="deleteVideo"
                @emitVideoShow="emitVideoShow"
                :videos="personData.videos"
              ></Videos>
            </v-tab-item>
            <v-tab-item>
              <Documents
                @download-file-demo="downloadFileDemo"
                :documents="documents"
              ></Documents>
            </v-tab-item>

            <v-tab-item>
              <div>
                <v-row class="mx-4 pb-0">
                  <v-col class="col-12 pb-0">
                    <v-alert
                      class="py-2"
                      border="left"
                      colored-border
                      color="border-primary"
                      elevation="2"
                    >
                      <p class="caption mb-0">
                        {{ lang.profile.suggestions.newPhotoSuggestion }}
                      </p>
                    </v-alert>
                  </v-col>
                  <v-col class="col-12 pb-0">
                    <v-row class="px-0 no-padding-mobile">
                      <v-col
                        class="col-12 col-md-4 pb-0"
                        v-for="suggestion in suggestions"
                        :key="suggestion.id"
                      >
                        <div
                          class="suggested-container"
                          @click="notAllowedInDemoMode = true"
                        >
                          <div class="mx-auto">
                            <v-avatar
                              width="40"
                              height="40"
                              min-height="40"
                              min-width="40"
                              color="grey"
                            >
                              <v-img
                                v-if="suggestion.profileImageUrl"
                                :src="suggestion.profileImageUrl"
                                :alt="suggestion.fullName"
                                :lazy-src="
                                  require('../../assets/images/lazy-loading.png')
                                "
                              ></v-img>
                              <div v-else>
                                {{ getFullNameInitials(suggestion.fullName) }}
                              </div>
                            </v-avatar>
                          </div>
                          <div class="suggested-content">
                            <p class="subtitle-2 font-weight-bold">
                              {{ suggestion.fullName }}
                            </p>
                            <p class="caption grey--text">
                              {{ suggestion.createdAt | getFormattedDate }}
                            </p>
                          </div>
                          <div>
                            <h3
                              class="display-1 font-weight-bold primary--text mb-n2"
                            >
                              {{ suggestion.totalSuggestion }}
                            </h3>
                            <p class="subtitle-2 grey--text">images</p>
                          </div>
                          <div>
                            <v-icon>mdi-arrow-right</v-icon>
                          </div>
                        </div>
                      </v-col>
                    </v-row>
                  </v-col>
                </v-row>
              </div>
            </v-tab-item>
          </v-tabs-items>
        </v-col>
      </v-row>
    </div>
  </div>
</template>
  
  <script>
import LikesDialog from "@/components/ProfileDialogs/LikesDialog.vue";
import FollowersDialog from "@/components/ProfileDialogs/FollowersDialog.vue";
import L from "leaflet";
import "leaflet/dist/leaflet.css";
import { mapGetters } from "vuex";
import Biography from "@/components/ProfileTabs/Biography.vue";
import Photos from "@/components/ProfileTabs/Photos.vue";
import Documents from "@/components/ProfileTabs/Documents.vue";
import Videos from "@/components/ProfileTabs/Videos.vue";
import LastGreeting from "@/components/ProfileTabs/LastGreeting.vue";
import NoResult from "../../components/noResult";
import helpers from "../../plugins/helpers.js";
import moment from "moment";
import QrcodeVue from "qrcode.vue";
import WeeklyTales from "../../components/WeeklyTales.vue";
import DemoImages from "../../script/demo/images.js";
import DemoVideos from "../../script/demo/videos.js";

delete L.Icon.Default.prototype._getIconUrl; // Reset default icon

L.Icon.Default.mergeOptions({
  iconRetinaUrl: "/img/mapIcons/marker-icon-2x.png",
  iconUrl: "/img/mapIcons/marker-icon.png",
  shadowUrl: "/img/mapIcons/marker-shadow.png",
});

export default {
  name: "Profile",
  data() {
    return {
      togglePanel: false,
      showAlert: true,
      showComment: false,
      suggestions: [
        {
          fullName: "Jane Smith",
          userId: "132",
          profileImageUrl: require("@/assets/images/demo/timelines/college-1-min.png"),
          totalSuggestion: 14,
          createdAt: "2024-11-01T13:23:02.6758161",
        },
        {
          fullName: "Boris Johnson",
          userId: "456",
          profileImageUrl: require("@/assets/images/demo/timelines/first-job-2-min.png"),
          totalSuggestion: 8,
          createdAt: "2024-11-05T02:23:02.6758161",
        },
        {
          fullName: "David Cameron",
          userId: "798",
          profileImageUrl: require("@/assets/images/demo/timelines/grandsons-min.jpg"),
          totalSuggestion: 24,
          createdAt: "2024-11-06T18:23:02.6758161",
        },
        {
          fullName: "Elisabeth Parker",
          userId: "369",
          profileImageUrl: require("@/assets/images/demo/timelines/wedding-1-min.png"),
          totalSuggestion: 57,
          createdAt: "2024-11-07T14:23:02.6758161",
        },
      ],
      weeklyTalesItems: [
        {
          url: require("@/assets/images/demo/timelines/1_new_born_baby.jpeg"),
          storyId: "01JC41914KYTD6F65KD78MSMS3",
          type: 0,
          createdAt: "2024-11-07T20:23:02.6758161",
          deceasedId: "01JC3EY85EDFGX5B03K2JFZX87",
          deceasedFullName: "John Doe",
        },
        {
          url: require("@/assets/images/demo/timelines/first-birthday-1-min.png"),
          storyId: "01JC41914KYTD6F65KD78MSMS3",
          type: 0,
          createdAt: "2024-11-07T20:23:02.6758161",
          deceasedId: "01JC3EY85EDFGX5B03K2JFZX87",
          deceasedFullName: "John Doe",
        },
        {
          url: require("@/assets/images/demo/timelines/first-steps-1-min.png"),
          storyId: "01JC41914KYTD6F65KD78MSMS3",
          type: 0,
          createdAt: "2024-11-07T20:23:02.6758161",
          deceasedId: "01JC3EY85EDFGX5B03K2JFZX87",
          deceasedFullName: "John Doe",
        },
        {
          url: require("@/assets/images/demo/timelines/first-steps-3-min.png"),
          storyId: "01JC41914KYTD6F65KD78MSMS3",
          type: 0,
          createdAt: "2024-11-07T20:23:02.6758161",
          deceasedId: "01JC3EY85EDFGX5B03K2JFZX87",
          deceasedFullName: "John Doe",
        },
        {
          url: require("@/assets/images/demo/timelines/bike-ride-1-min.png"),
          storyId: "01JC41914KYTD6F65KD78MSMS3",
          type: 0,
          createdAt: "2024-11-07T20:23:02.6758161",
          deceasedId: "01JC3EY85EDFGX5B03K2JFZX87",
          deceasedFullName: "John Doe",
        },
        {
          url: require("@/assets/images/demo/timelines/1st-school-day-min.png"),
          storyId: "01JC41914KYTD6F65KD78MSMS3",
          type: 0,
          createdAt: "2024-11-07T20:23:02.6758161",
          deceasedId: "01JC3EY85EDFGX5B03K2JFZX87",
          deceasedFullName: "John Doe",
        },
        {
          url: require("@/assets/images/demo/timelines/college-2-min.png"),
          storyId: "01JC41914KYTD6F65KD78MSMS3",
          type: 0,
          createdAt: "2024-11-07T20:23:02.6758161",
          deceasedId: "01JC3EY85EDFGX5B03K2JFZX87",
          deceasedFullName: "John Doe",
        },
        {
          url: require("@/assets/images/demo/timelines/first-job-1-min.png"),
          storyId: "01JC41914KYTD6F65KD78MSMS3",
          type: 0,
          createdAt: "2024-11-07T20:23:02.6758161",
          deceasedId: "01JC3EY85EDFGX5B03K2JFZX87",
          deceasedFullName: "John Doe",
        },
        {
          url: require("@/assets/images/demo/timelines/wedding-1-min.png"),
          storyId: "01JC41914KYTD6F65KD78MSMS3",
          type: 0,
          createdAt: "2024-11-07T20:23:02.6758161",
          deceasedId: "01JC3EY85EDFGX5B03K2JFZX87",
          deceasedFullName: "John Doe",
        },
        {
          url: require("@/assets/images/demo/timelines/published-2-min.png"),
          storyId: "01JC41914KYTD6F65KD78MSMS3",
          type: 0,
          createdAt: "2024-11-07T20:23:02.6758161",
          deceasedId: "01JC3EY85EDFGX5B03K2JFZX87",
          deceasedFullName: "John Doe",
        },
        {
          url: require("@/assets/images/demo/timelines/expand-min.png"),
          storyId: "01JC41914KYTD6F65KD78MSMS3",
          type: 0,
          createdAt: "2024-11-07T20:23:02.6758161",
          deceasedId: "01JC3EY85EDFGX5B03K2JFZX87",
          deceasedFullName: "John Doe",
        },
      ],
      imagesPage: 1,
      notAllowedInDemoMode: false,
      lastGreetings: [
        {
          id: "01HZYPJ3X1544X0YMBD62RNS1Y",
          byUserId: "01H1F22K47ZPK57TYBHV763166",
          byUserFullName: "Alexandra Doe",
          personId: "01HBV2F63YAVY21T6SQQFSTH38",
          note: "John, from the moment we met, I knew you were someone special. Your unwavering support and endless kindness have shaped me and everyone around you. As I say goodbye, I want to thank you for every shared moment, every laugh, every comforting word. You will always be in our hearts.",
          createdAt: "2024-08-11T14:31:12.0332397Z",
          byUserImage: require(`../../assets/images/profiles/profile-woman-1-min.jpg`),
        },
        {
          id: "01HZYPJ3X1544X0YMBD62RNS1Y",
          byUserId: "01H1F22K47ZPK57TYBHV763166",
          byUserFullName: "Jane Smith",
          personId: "01HBV2F63YAVY21T6SQQFSTH38",
          note: "John, you were always the first to lend a hand. I'll miss your kindness more than words can say.",
          createdAt: "2024-07-08T13:28:15.0332397Z",
          byUserImage: require(`../../assets/images/profiles/profile-woman-2-min.jpg`),
        },
        {
          id: "01HZYPJ3X1544X0YMBD62RNS1Y",
          byUserId: "01H1F22K47ZPK57TYBHV763166",
          byUserFullName: "Alice Johnson",
          personId: "01HBV2F63YAVY21T6SQQFSTH38",
          note: "I still can't believe you're gone, John. You had this incredible ability to make everyone feel seen and valued. Your smile could light up a room, and your wisdom was a gift to us all. I will carry your lessons and love with me, always striving to live up to the example you set. Rest well, my dear friend.",
          createdAt: "2024-07-01T10:11:12.0332397Z",
          byUserImage: require(`../../assets/images/profiles/profile-woman-3-min.jpg`),
        },
        {
          id: "01HZYPJ3X1544X0YMBD62RNS1Y",
          byUserId: "01H1F22K47ZPK57TYBHV763166",
          byUserFullName: "Emily Davis",
          personId: "01HBV2F63YAVY21T6SQQFSTH38",
          note: "Rest well, my friend. You touched so many lives and left a legacy of love and laughter.",
          createdAt: "2024-06-29T18:41:12.0332397Z",
          byUserImage: null,
        },
        {
          id: "01HZYPJ3X1544X0YMBD62RNS1Y",
          byUserId: "01H1F22K47ZPK57TYBHV763166",
          byUserFullName: "David Moore",
          personId: "01HBV2F63YAVY21T6SQQFSTH38",
          note: "Goodbye, John. I can't express how much your presence meant to me. You were the calm in life's storms, always there with a word of encouragement or just a quiet, understanding nod. You helped me in ways you'll never know. Though you're no longer here in body, your spirit will guide us forever.",
          createdAt: "2024-06-12T19:33:12.0332397Z",
          byUserImage: require(`../../assets/images/profiles/profile-man-11-min.jpg`),
        },
        {
          id: "01HZYPJ3X1544X0YMBD62RNS1Y",
          byUserId: "01H1F22K47ZPK57TYBHV763166",
          byUserFullName: "Sarah Miller",
          personId: "01HBV2F63YAVY21T6SQQFSTH38",
          note: "I'll never forget the way you made everyone feel like family. Goodbye, John.",
          createdAt: "2024-06-09T14:31:12.0332397Z",
          byUserImage: null,
        },
        {
          id: "01HZYPJ3X1544X0YMBD62RNS1Y",
          byUserId: "01H1F22K47ZPK57TYBHV763166",
          byUserFullName: "Laura Taylor",
          personId: "01HBV2F63YAVY21T6SQQFSTH38",
          note: "John, I find it hard to say farewell because it feels so final, but I know that your spirit will never leave us. You had a way of bringing people together, making everyone feel like they belonged. I will forever be grateful for the times we shared and the person you were. Your memory will live on through all of us.",
          createdAt: "2024-05-15T15:59:12.0332397Z",
          byUserImage: require(`../../assets/images/profiles/profile-woman-6-min.jpg`),
        },
        {
          id: "01HZYPJ3X1544X0YMBD62RNS1Y",
          byUserId: "01H1F22K47ZPK57TYBHV763166",
          byUserFullName: "James Anderson",
          personId: "01HBV2F63YAVY21T6SQQFSTH38",
          note: "You were the heartbeat of our circle, John. You were always the one to lift us up, to inspire us with your courage and positivity. Even in the hardest times, you showed us what it meant to live with grace and dignity. I'll miss you more than words can express, but I'm thankful for the time we had together. Rest easy, dear friend.",
          createdAt: "2024-05-11T20:11:12.0332397Z",
          byUserImage: require(`../../assets/images/profiles/profile-man-7-min.jpg`),
        },
        {
          id: "01HZYPJ3X1544X0YMBD62RNS1Y",
          byUserId: "01H1F22K47ZPK57TYBHV763166",
          byUserFullName: "Linda Thomas",
          personId: "01HBV2F63YAVY21T6SQQFSTH38",
          note: "Thank you for always being there, John. You were a light in all our lives.",
          createdAt: "2024-05-09T14:31:12.0332397Z",
          byUserImage: require(`../../assets/images/profiles/profile-woman-8-min.jpg`),
        },
        {
          id: "01HZYPJ3X1544X0YMBD62RNS1Y",
          byUserId: "01H1F22K47ZPK57TYBHV763166",
          byUserFullName: "Chris Martin",
          personId: "01HBV2F63YAVY21T6SQQFSTH38",
          note: "You were the heartbeat of our circle, John. You were always the one to lift us up, to inspire us with your courage and positivity. Even in the hardest times, you showed us what it meant to live with grace and dignity. I'll miss you more than words can express, but I'm thankful for the time we had together. Rest easy, dear friend.",
          createdAt: "2024-04-24T17:21:12.0332397Z",
          byUserImage: require(`../../assets/images/profiles/profile-man-9-min.jpg`),
        },
        {
          id: "01HZYPJ3X1544X0YMBD62RNS1Y",
          byUserId: "01H1F22K47ZPK57TYBHV763166",
          byUserFullName: "Jessica Lee",
          personId: "01HBV2F63YAVY21T6SQQFSTH38",
          note: "It's hard to imagine a world without you in it, John. You were the kind of person who left a lasting impact on everyone you met. You taught me what it means to live authentically, to love deeply, and to face challenges with courage. You may be gone, but the mark you left on all of us will never fade. Until we meet again, my friend.",
          createdAt: "2024-04-19T14:31:12.0332397Z",
          byUserImage: null,
        },
        {
          id: "01HZYPJ3X1544X0YMBD62RNS1Y",
          byUserId: "01H1F22K47ZPK57TYBHV763166",
          byUserFullName: "Daniel Harris",
          personId: "01HBV2F63YAVY21T6SQQFSTH38",
          note: "John, you were a rare soul, someone who could touch a person's heart without even trying. You had a gift for making life feel a little lighter, even in the darkest moments. I'll miss your wisdom, your humor, and the way you always made time for everyone. Thank you for being such an important part of my life.",
          createdAt: "2024-03-30T12:10:12.0332397Z",
          byUserImage: require(`../../assets/images/profiles/profile-man-10-min.jpg`),
        },
        {
          id: "01HZYPJ3X1544X0YMBD62RNS1Y",
          byUserId: "01H1F22K47ZPK57TYBHV763166",
          byUserFullName: "Matthew Lewis",
          personId: "01HBV2F63YAVY21T6SQQFSTH38",
          note: "Goodbye, John. Your presence brought joy to so many. You'll live on in our hearts.",
          createdAt: "2024-03-26T14:31:12.0332397Z",
          byUserImage: null,
        },
        {
          id: "01HZYPJ3X1544X0YMBD62RNS1Y",
          byUserId: "01H1F22K47ZPK57TYBHV763166",
          byUserFullName: "Olivia Walker",
          personId: "01HBV2F63YAVY21T6SQQFSTH38",
          note: "It's hard to say goodbye, John. Your spirit will always be with us.",
          createdAt: "2024-03-14T15:00:12.0332397Z",
          byUserImage: require(`../../assets/images/profiles/profile-woman-11-min.jpg`),
        },
        {
          id: "01HZYPJ3X1544X0YMBD62RNS1Y",
          byUserId: "01H1F22K47ZPK57TYBHV763166",
          byUserFullName: "Joshua Hall",
          personId: "01HBV2F63YAVY21T6SQQFSTH38",
          note: "You were always full of life, John. I will cherish our memories forever.",
          createdAt: "2024-03-09T18:39:12.0332397Z",
          byUserImage: require(`../../assets/images/profiles/profile-man-13-min.jpg`),
        },
        {
          id: "01HZYPJ3X1544X0YMBD62RNS1Y",
          byUserId: "01H1F22K47ZPK57TYBHV763166",
          byUserFullName: "Isabella Young",
          personId: "01HBV2F63YAVY21T6SQQFSTH38",
          note: "John, you were more than a friend; you were family. Rest in peace.",
          createdAt: "2024-03-03T03:11:12.0332397Z",
          byUserImage: null,
        },
        {
          id: "01HZYPJ3X1544X0YMBD62RNS1Y",
          byUserId: "01H1F22K47ZPK57TYBHV763166",
          byUserFullName: "Andrew King",
          personId: "01HBV2F63YAVY21T6SQQFSTH38",
          note: "You left us too soon, John. Your spirit will always be with us.",
          createdAt: "2024-02-27T16:44:12.0332397Z",
          byUserImage: null,
        },
        {
          id: "01HZYPJ3X1544X0YMBD62RNS1Y",
          byUserId: "01H1F22K47ZPK57TYBHV763166",
          byUserFullName: "Mia Wright",
          personId: "01HBV2F63YAVY21T6SQQFSTH38",
          note: "I can't believe you're gone, John. I will carry your memory with me always.",
          createdAt: "2024-02-20T19:17:12.0332397Z",
          byUserImage: require(`../../assets/images/profiles/profile-woman-5-min.jpg`),
        },
        {
          id: "01HZYPJ3X1544X0YMBD62RNS1Y",
          byUserId: "01H1F22K47ZPK57TYBHV763166",
          byUserFullName: "Ethan Scott",
          personId: "01HBV2F63YAVY21T6SQQFSTH38",
          note: "Thank you for all the moments of wisdom and joy you shared with us, John.",
          createdAt: "2024-02-18T14:45:12.0332397Z",
          byUserImage: require(`../../assets/images/profiles/profile-man-6-min.jpg`),
        },
        {
          id: "01HZYPJ3X1544X0YMBD62RNS1Y",
          byUserId: "01H1F22K47ZPK57TYBHV763166",
          byUserFullName: "Ava Green",
          personId: "01HBV2F63YAVY21T6SQQFSTH38",
          note: "Rest peacefully, my dear friend. Your kindness and love were felt by all.",
          createdAt: "2024-02-09T14:31:12.0332397Z",
          byUserImage: null,
        },
        {
          id: "01HZYPJ3X1544X0YMBD62RNS1Y",
          byUserId: "01H1F22K47ZPK57TYBHV763166",
          byUserFullName: "Alexander Adams",
          personId: "01HBV2F63YAVY21T6SQQFSTH38",
          note: "I'll miss our long talks, John. You always knew how to make everything better.",
          createdAt: "2024-02-07T16:18:12.0332397Z",
          byUserImage: require(`../../assets/images/profiles/profile-woman-4-min.jpg`),
        },
        {
          id: "01HZYPJ3X1544X0YMBD62RNS1Y",
          byUserId: "01H1F22K47ZPK57TYBHV763166",
          byUserFullName: "Charlotte Baker",
          personId: "01HBV2F63YAVY21T6SQQFSTH38",
          note: "Your laughter will echo in our hearts forever, John. Goodbye, my dear friend.",
          createdAt: "2024-02-02T11:25:12.0332397Z",
          byUserImage: null,
        },
        {
          id: "01HZYPJ3X1544X0YMBD62RNS1Y",
          byUserId: "01H1F22K47ZPK57TYBHV763166",
          byUserFullName: "William Nelson",
          personId: "01HBV2F63YAVY21T6SQQFSTH38",
          note: "Goodbye, John. Your presence brought joy to so many. You'll live on in our hearts.",
          createdAt: "2024-01-30T22:31:12.0332397Z",
          byUserImage: require(`../../assets/images/profiles/profile-man-5-min.jpg`),
        },
      ],
      biographies: [
        {
          title: "Born",
          description:
            "John was born on a cold winter day in Chicago, beginning a life full of promise and adventure.",
          from: "1958-02-07",
          to: null,
          id: "01J75N0SV39WDW6A7XVQBSDDYN",
          personId: "01HBV2F63YAVY21T6SQQFSTH38",
          userId: "no",
          assets: [
            {
              url: require("@/assets/images/demo/timelines/1_new_born_baby.jpeg"),
              type: 1,
            },
            {
              url: require("@/assets/images/demo/timelines/newborn-baby-parent-holding.png"),
              type: 1,
            },
            {
              url: require("@/assets/images/demo/timelines/newborn-baby-with-parents.png"),
              type: 1,
            },
          ],
        },
        {
          title: "John's first birthday celebration",
          description:
            "John celebrated his first birthday surrounded by family and friends.",
          from: "1959-02-07",
          to: null,
          id: "01J75N0SV39WDW6A7XVQBSDDYN",
          personId: "01HBV2F63YAVY21T6SQQFSTH38",
          userId: "01H1F22K47ZPK57TYBHV763166",
          assets: [
            {
              url: require("@/assets/images/demo/timelines/first-birthday-1-min.png"),
              type: 1,
            },
            {
              url: require("@/assets/images/demo/timelines/first-birthday-min.png"),
              type: 1,
            },
          ],
        },
        {
          title: "John's first steps",
          description:
            "At age 1, John took his first steps, filling his family with joy and pride.",
          from: "1953-11-13",
          to: null,
          id: "01J75N0SV39WDW6A7XVQBSDDYN",
          personId: "01HBV2F63YAVY21T6SQQFSTH38",
          userId: "01H1F22K47ZPK57TYBHV763166",
          assets: [
            {
              url: require("@/assets/images/demo/timelines/first-steps-1-min.png"),
              type: 1,
            },
            {
              url: require("@/assets/images/demo/timelines/first-steps-2-min.png"),
              type: 1,
            },
            {
              url: require("@/assets/images/demo/timelines/first-steps-3-min.png"),
              type: 1,
            },
          ],
        },
        {
          title: "John's first bike ride",
          description:
            "At age 4, John learned to ride a bike, a skill that would take him on many adventures.",
          from: "1953-05-01",
          to: null,
          id: "01J75N0SV39WDW6A7XVQBSDDYN",
          personId: "01HBV2F63YAVY21T6SQQFSTH38",
          userId: "01H1F22K47ZPK57TYBHV763166",
          assets: [
            {
              url: require("@/assets/images/demo/timelines/bike-ride-1-min.png"),
              type: 1,
            },
            {
              url: require("@/assets/images/demo/timelines/bike-ride-2-min.png"),
              type: 1,
            },
            {
              url: require("@/assets/images/demo/timelines/bike-ride-3-min.png"),
              type: 1,
            },
            {
              url: require("@/assets/images/demo/timelines/bike-ride-4-min.png"),
              type: 1,
            },
          ],
        },
        {
          title: "Started School",
          description:
            "At age 7, John entered elementary school, where his curiosity for science began to flourish.",
          from: "1966-09-01",
          to: null,
          id: "01J75N0SV39WDW6A7XVQBSDDYN",
          personId: "01HBV2F63YAVY21T6SQQFSTH38",
          userId: "01H1F22K47ZPK57TYBHV763166",
          assets: [
            {
              url: require("@/assets/images/demo/timelines/1st-school-day-min.png"),
              type: 1,
            },
          ],
        },
        {
          title: "Won First Science Fair",
          description:
            "In the 5th grade, John won first place at the local science fair for his homemade solar-powered car.",
          from: "1969-04-15",
          to: null,
          id: "01J75N0SV39WDW6A7XVQBSDDYN",
          personId: "01HBV2F63YAVY21T6SQQFSTH38",
          userId: "01H1F22K47ZPK57TYBHV763166",
        },
        {
          title: "Graduated High School",
          description:
            "John graduated with honors from Lincoln High School, where he excelled in science and mathematics.",
          from: "1978-06-15",
          to: null,
          id: "01J75N0SV39WDW6A7XVQBSDDYN",
          personId: "01HBV2F63YAVY21T6SQQFSTH38",
          userId: "01H1F22K47ZPK57TYBHV763166",
        },
        {
          title: "Started College",
          description:
            "John enrolled at the University of Illinois, majoring in Physics and Mathematics.",
          from: "1978-09-01",
          to: null,
          id: "01J75N0SV39WDW6A7XVQBSDDYN",
          personId: "01HBV2F63YAVY21T6SQQFSTH38",
          userId: "01H1F22K47ZPK57TYBHV763166",
          assets: [
            {
              url: require("@/assets/images/demo/timelines/college-1-min.png"),
              type: 1,
            },
            {
              url: require("@/assets/images/demo/timelines/college-2-min.png"),
              type: 1,
            },
          ],
        },
        {
          title: "Internship at NASA",
          description:
            "During his junior year in college, John landed an internship with NASA, where he contributed to research on renewable energy.",
          from: "1979-06-15",
          to: null,
          id: "01J75N0SV39WDW6A7XVQBSDDYN",
          personId: "01HBV2F63YAVY21T6SQQFSTH38",
          userId: "01H1F22K47ZPK57TYBHV763166",
        },
        {
          title: "Graduated from College",
          description:
            "John graduated with a Bachelor's degree in Physics from the University of Illinois.",
          from: "1982-08-23",
          to: null,
          id: "01J75N0SV39WDW6A7XVQBSDDYN",
          personId: "01HBV2F63YAVY21T6SQQFSTH38",
          userId: "01H1F22K47ZPK57TYBHV763166",
          assets: [
            {
              url: require("@/assets/images/demo/timelines/graduated-1-min.png"),
              type: 1,
            },
            {
              url: require("@/assets/images/demo/timelines/graduated-2-min.png"),
              type: 1,
            },
            {
              url: require("@/assets/images/demo/timelines/graduated-3-min.png"),
              type: 1,
            },
            {
              url: require("@/assets/images/demo/timelines/graduated-4-min.png"),
              type: 1,
            },
          ],
        },
        {
          title: "First Job",
          description:
            "John began his career at a leading tech company, working on developing renewable energy technologies.",
          from: "1983-02-14",
          to: null,
          id: "01J75N0SV39WDW6A7XVQBSDDYN",
          personId: "01HBV2F63YAVY21T6SQQFSTH38",
          userId: "01H1F22K47ZPK57TYBHV763166",
          assets: [
            {
              url: require("@/assets/images/demo/timelines/first-job-1-min.png"),
              type: 1,
            },
            {
              url: require("@/assets/images/demo/timelines/first-job-2-min.png"),
              type: 1,
            },
          ],
        },
        {
          title: "Published First Research Paper",
          description:
            "John's first research paper on solar energy solutions was published in a scientific journal.",
          from: "1986-03-14",
          to: null,
          id: "01J75N0SV39WDW6A7XVQBSDDYN",
          personId: "01HBV2F63YAVY21T6SQQFSTH38",
          userId: "01H1F22K47ZPK57TYBHV763166",
          assets: [
            {
              url: require("@/assets/images/demo/timelines/published-1-min.png"),
              type: 1,
            },
            {
              url: require("@/assets/images/demo/timelines/published-2-min.png"),
              type: 1,
            },
          ],
        },
        {
          title: "Earned PhD in Renewable Energy",
          description:
            "John completed his PhD in Renewable Energy from MIT, focusing on innovative solutions to energy efficiency.",
          from: "1987-06-30",
          to: null,
          id: "01J75N0SV39WDW6A7XVQBSDDYN",
          personId: "01HBV2F63YAVY21T6SQQFSTH38",
          userId: "01H1F22K47ZPK57TYBHV763166",
        },
        {
          title: "Married Jane Smith",
          description:
            "John married his college sweetheart, Jane Smith, in a small ceremony with close family and friends.",
          from: "1988-09-01",
          to: null,
          id: "01J75N0SV39WDW6A7XVQBSDDYN",
          personId: "01HBV2F63YAVY21T6SQQFSTH38",
          userId: "01H1F22K47ZPK57TYBHV763166",
          assets: [
            {
              url: require("@/assets/images/demo/timelines/wedding-1-min.png"),
              type: 1,
            },
            {
              url: require("@/assets/images/demo/timelines/wedding-2-min.png"),
              type: 1,
            },
            {
              url: require("@/assets/images/demo/timelines/wedding-3-min.png"),
              type: 1,
            },
            {
              url: require("@/assets/images/demo/timelines/wedding-4-min.png"),
              type: 1,
            },
          ],
        },
        {
          title: "First Child Born - Adam",
          description:
            "John and Jane welcomed their first child, Adam, a beautiful baby boy.",
          from: "1989-05-05",
          to: null,
          id: "01J75N0SV39WDW6A7XVQBSDDYN",
          personId: "01HBV2F63YAVY21T6SQQFSTH38",
          userId: "01H1F22K47ZPK57TYBHV763166",
          assets: [
            {
              url: require("@/assets/images/demo/timelines/new-baby-1-min.png"),
              type: 1,
            },
            {
              url: require("@/assets/images/demo/timelines/new-baby-min.png"),
              type: 1,
            },
          ],
        },
        {
          title: "Moved to California",
          description:
            "John and his family moved to Silicon Valley, where he took a senior role at a tech startup focusing on green energy.",
          from: "1990-03-12",
          to: null,
          id: "01J75N0SV39WDW6A7XVQBSDDYN",
          personId: "01HBV2F63YAVY21T6SQQFSTH38",
          userId: "01H1F22K47ZPK57TYBHV763166",
          assets: [
            {
              url: require("@/assets/images/demo/timelines/new-house-1-min.png"),
              type: 1,
            },
            {
              url: require("@/assets/images/demo/timelines/new-house-2-min.png"),
              type: 1,
            },
          ],
        },
        {
          title: "Second Child Born - Sophie",
          description:
            "John and Jane had their second child, a girl named Sophie.",
          from: "1992-07-22",
          to: null,
          id: "01J75N0SV39WDW6A7XVQBSDDYN",
          personId: "01HBV2F63YAVY21T6SQQFSTH38",
          userId: "01H1F22K47ZPK57TYBHV763166",
          assets: [
            {
              url: require("@/assets/images/demo/timelines/2nd-child-1-min.jpg"),
              type: 1,
            },
            {
              url: require("@/assets/images/demo/timelines/2nd-child-2-min.jpg"),
              type: 1,
            },
          ],
        },
        {
          title: "Founded Renewable Energy Company",
          description:
            "John co-founded a company dedicated to advancing solar energy technologies.",
          from: "1995-09-10",
          to: null,
          id: "01J75N0SV39WDW6A7XVQBSDDYN",
          personId: "01HBV2F63YAVY21T6SQQFSTH38",
          userId: "01H1F22K47ZPK57TYBHV763166",
        },
        {
          title: "Published Book on Solar Energy",
          description:
            "John published a groundbreaking book on the future of solar energy and its impact on global sustainability.",
          from: "1998-11-05",
          to: null,
          id: "01J75N0SV39WDW6A7XVQBSDDYN",
          personId: "01HBV2F63YAVY21T6SQQFSTH38",
          userId: "01H1F22K47ZPK57TYBHV763166",
          assets: [
            {
              url: require("@/assets/images/demo/timelines/book-min.png"),
              type: 1,
            },
          ],
        },
        {
          title: "Awarded Innovator of the Year",
          description:
            "John was recognized as Innovator of the Year by the Green Technology Association for his contributions to renewable energy.",
          from: "2001-03-18",
          to: null,
          id: "01J75N0SV39WDW6A7XVQBSDDYN",
          personId: "01HBV2F63YAVY21T6SQQFSTH38",
          userId: "01H1F22K47ZPK57TYBHV763166",
          assets: [],
        },
        {
          title: "Expanded Company Internationally",
          description:
            "John's company expanded internationally, opening branches in Europe and Asia.",
          from: "2004-07-19",
          to: null,
          id: "01J75N0SV39WDW6A7XVQBSDDYN",
          personId: "01HBV2F63YAVY21T6SQQFSTH38",
          userId: "01H1F22K47ZPK57TYBHV763166",
          assets: [
            {
              url: require("@/assets/images/demo/timelines/expand-min.png"),
              type: 1,
            },
          ],
        },
        {
          title: "Joined United Nations Panel",
          description:
            "John was invited to join the United Nations' panel on climate change and renewable energy.",
          from: "2006-10-30",
          to: null,
          id: "01J75N0SV39WDW6A7XVQBSDDYN",
          personId: "01HBV2F63YAVY21T6SQQFSTH38",
          userId: "01H1F22K47ZPK57TYBHV763166",
        },
        {
          title: "Retired from CEO Position",
          description:
            "John stepped down from his CEO role to focus on philanthropy and mentoring young entrepreneurs.",
          from: "2012-05-15",
          to: null,
          id: "01J75N0SV39WDW6A7XVQBSDDYN",
          personId: "01HBV2F63YAVY21T6SQQFSTH38",
          userId: "01H1F22K47ZPK57TYBHV763166",
          assets: [
            {
              url: require("@/assets/images/demo/timelines/retired-min.jpg"),
              type: 1,
            },
            {
              url: require("@/assets/images/demo/timelines/retired-2-min.jpg"),
              type: 1,
            },
          ],
        },
        {
          title: "Honored with Lifetime Achievement Award",
          description:
            "John received a Lifetime Achievement Award for his contributions to renewable energy and environmental sustainability.",
          from: "2014-04-21",
          to: null,
          id: "01J75N0SV39WDW6A7XVQBSDDYN",
          personId: "01HBV2F63YAVY21T6SQQFSTH38",
          userId: "01H1F22K47ZPK57TYBHV763166",
          assets: [
            {
              url: require("@/assets/images/demo/timelines/award-1-min.png"),
              type: 1,
            },
            {
              url: require("@/assets/images/demo/timelines/award-2-min.png"),
              type: 1,
            },
            {
              url: require("@/assets/images/demo/timelines/award-3-min.png"),
              type: 1,
            },
          ],
        },
        {
          title: "Grandchild Born",
          description:
            "John's first grandchild, Olivia, was born to his daughter Emily.",
          from: "2015-08-30",
          to: null,
          id: "01J75N0SV39WDW6A7XVQBSDDYN",
          personId: "01HBV2F63YAVY21T6SQQFSTH38",
          userId: "01H1F22K47ZPK57TYBHV763166",
          assets: [
            {
              url: require("@/assets/images/demo/timelines/grandparents-1-min.jpg"),
              type: 1,
            },
            {
              url: require("@/assets/images/demo/timelines/grandparents-min.jpg"),
              type: 1,
            },
          ],
        },
        {
          title: "Guest Lecturer at Harvard",
          description:
            "John became a guest lecturer at Harvard, where he shared his insights on green technology and entrepreneurship.",
          from: "2017-10-03",
          to: null,
          id: "01J75N0SV39WDW6A7XVQBSDDYN",
          personId: "01HBV2F63YAVY21T6SQQFSTH38",
          userId: "01H1F22K47ZPK57TYBHV763166",
          assets: [
            {
              url: require("@/assets/images/demo/timelines/lecture-min.png"),
              type: 1,
            },
          ],
        },
        {
          title: "Traveled Around the World",
          description:
            "John and Jane embarked on a world tour, visiting sustainable energy projects across the globe.",
          from: "2018-05-25",
          to: null,
          id: "01J75N0SV39WDW6A7XVQBSDDYN",
          personId: "01HBV2F63YAVY21T6SQQFSTH38",
          userId: "01H1F22K47ZPK57TYBHV763166",
          assets: [
            {
              url: require("@/assets/images/demo/timelines/beach-walk-min.jpg"),
              type: 1,
            },
            {
              url: require("@/assets/images/demo/timelines/deck-min.jpg"),
              type: 1,
            },
            {
              url: require("@/assets/images/demo/timelines/mountain-min.jpg"),
              type: 1,
            },
            {
              url: require("@/assets/images/demo/timelines/summer-min.jpg"),
              type: 1,
            },
          ],
        },
        {
          title: "Battled Illness",
          description:
            "John was diagnosed with a chronic illness and began reducing his public appearances.",
          from: "2020-10-11",
          to: null,
          id: "01J75N0SV39WDW6A7XVQBSDDYN",
          personId: "01HBV2F63YAVY21T6SQQFSTH38",
          userId: "01H1F22K47ZPK57TYBHV763166",
          assets: [],
        },
        {
          title: "Passed Away",
          description:
            "John passed away peacefully at home, surrounded by family, leaving behind a legacy of innovation and dedication to a sustainable future.",
          from: "2023-05-16",
          to: null,
          id: "01J75N0SV39WDW6A7XVQBSDDYN",
          personId: "01HBV2F63YAVY21T6SQQFSTH38",
          userId: "01H1F22K47ZPK57TYBHV763166",
          assets: [
            {
              url: require("@/assets/images/demo/timelines/passed-away-1-min.png"),
              type: 1,
            },
            {
              url: require("@/assets/images/demo/timelines/passed-away-2-min.png"),
              type: 1,
            },
            {
              url: require("@/assets/images/demo/timelines/passed-away-2-min.png"),
              type: 1,
            },
            {
              url: require("@/assets/images/demo/timelines/old-in-love-min.jpg"),
              type: 1,
            },
          ],
        },
      ],
      followerList: [
        {
          userFullName: "Alexandra Doe",
          profileImageUrl: require(`../../assets/images/profiles/profile-woman-1-min.jpg`),
          imageName: null,
        },
        {
          userFullName: "Jane Smith",
          profileImageUrl: require(`../../assets/images/profiles/profile-woman-2-min.jpg`),
          imageName: null,
        },
        {
          userFullName: "Alice Johnson",
          profileImageUrl: require(`../../assets/images/profiles/profile-woman-3-min.jpg`),
          imageName: null,
        },
        {
          userFullName: "Robert Brown",
          profileImageUrl: null,
          imageName: null,
        },
        {
          userFullName: "Emily Davis",
          profileImageUrl: null,
          imageName: null,
        },
        {
          userFullName: "Michael Wilson",
          profileImageUrl: require(`../../assets/images/profiles/profile-man-3-min.jpg`),
          imageName: null,
        },
        { userFullName: "Sarah Miller", imageUrl: null, imageName: null },
        {
          userFullName: "David Moore",
          profileImageUrl: require(`../../assets/images/profiles/profile-man-11-min.jpg`),
          imageName: null,
        },
        {
          userFullName: "Laura Taylor",
          profileImageUrl: require(`../../assets/images/profiles/profile-woman-6-min.jpg`),
          imageName: null,
        },
        {
          userFullName: "James Anderson",
          profileImageUrl: require(`../../assets/images/profiles/profile-man-7-min.jpg`),
          imageName: null,
        },
        {
          userFullName: "Linda Thomas",
          profileImageUrl: require(`../../assets/images/profiles/profile-woman-8-min.jpg`),
          imageName: null,
        },
        {
          userFullName: "Chris Martin",
          profileImageUrl: require(`../../assets/images/profiles/profile-man-9-min.jpg`),
          imageName: null,
        },
        { userFullName: "Jessica Lee", profileImageUrl: null, imageName: null },
        {
          userFullName: "Daniel Harris",
          profileImageUrl: require(`../../assets/images/profiles/profile-man-10-min.jpg`),
          imageName: null,
        },
        {
          userFullName: "Sophia Clark",
          profileImageUrl: null,
          imageName: null,
        },
        {
          userFullName: "Matthew Lewis",
          profileImageUrl: null,
          imageName: null,
        },
        {
          userFullName: "Olivia Walker",
          profileImageUrl: require(`../../assets/images/profiles/profile-woman-11-min.jpg`),
          imageName: null,
        },
        {
          userFullName: "Joshua Hall",
          profileImageUrl: require(`../../assets/images/profiles/profile-man-13-min.jpg`),
          imageName: null,
        },
        {
          userFullName: "Isabella Young",
          profileImageUrl: null,
          imageName: null,
        },
        { userFullName: "Andrew King", profileImageUrl: null, imageName: null },
        {
          userFullName: "Mia Wright",
          profileImageUrl: require(`../../assets/images/profiles/profile-woman-5-min.jpg`),
          imageName: null,
        },
        {
          userFullName: "Ethan Scott",
          profileImageUrl: require(`../../assets/images/profiles/profile-man-6-min.jpg`),
          imageName: null,
        },
        {
          userFullName: "Ava Green",
          profileImageUrl: null,
          imageName: null,
        },
        {
          userFullName: "Alexander Adams",
          profileImageUrl: require(`../../assets/images/profiles/profile-man-4-min.jpg`),
          imageName: null,
        },
        {
          userFullName: "Charlotte Baker",
          profileImageUrl: null,
          imageName: null,
        },
        {
          userFullName: "William Nelson",
          profileImageUrl: require(`../../assets/images/profiles/profile-man-5-min.jpg`),
          imageName: null,
        },
      ],
      likeList: [],
      dialogFollow: false,
      description: "",
      showInfoEdit: false,
      isUpdating: false,
      infoDateMenu: false,
      activePickerInfo: null,
      info: {
        imageId: "",
        location: "",
        title: "",
        description: "",
        memoryDate: null,
        friends: [],
      },
      showInfo: false,
      showQrCodePopup: false,
      shareableLink: "",
      shareableDescription: "",
      shareableQuote: "",
      showShareSocialActionsPopup: false,
      networks: [
        {
          network: "viber",
          name: "Viber",
          icon: "mdi-viber",
          color: "#59267c",
        },
        {
          network: "email",
          name: "Email",
          icon: "mdi-email-outline",
          color: "#333333",
        },
        {
          network: "reddit",
          name: "Reddit",
          icon: "mdi-reddit",
          color: "#ff4500",
        },
        {
          network: "facebook",
          name: "Facebook",
          icon: "mdi-facebook",
          color: "#1877f2",
        },
        {
          network: "linkedin",
          name: "LinkedIn",
          icon: "mdi-linkedin",
          color: "#007bb5",
        },
        {
          network: "messenger",
          name: "Messenger",
          icon: "mdi-facebook-messenger",
          color: "#0084ff",
        },
        {
          network: "pinterest",
          name: "Pinterest",
          icon: "mdi-pinterest",
          color: "#bd081c",
        },
        {
          network: "skype",
          name: "Skype",
          icon: "mdi-skype-business",
          color: "#00aff0",
        },
        {
          network: "telegram",
          name: "Telegram",
          icon: "mdi-telegram",
          color: "#0088cc",
        },
        {
          network: "twitter",
          name: "Twitter",
          icon: "mdi-twitter",
          color: "#1da1f2",
        },
        {
          network: "whatsapp",
          name: "Whatsapp",
          icon: "mdi-whatsapp",
          color: "#25d366",
        },
      ],
      threadList: null,
      imageComment: "",
      imageCommentThread: "",
      videoCommentThread: "",
      videoComment: "",
      imageShowIndex: null,
      videoShowIndex: null,
      dialog: false,
      dialogVideo: false,
      notifications: false,
      sound: true,
      widgets: false,
      dialogFollowers: false,
      tabSelected: 0,
      dialogInvite: false,
      inviteEmails: [],
      inviteEmail: "",
      editMode: false,
      personDataClone: {},
      dateOfBirthMenu: false,
      dateOfDeathMenu: false,
      activePickerBirth: null,
      activePickerDeath: null,
      lastGreetingNote: "",
      lastGreetingModel: false,
      currentGreeting: null,
      currentImage: null,
      currentVideo: null,
      currentComment: null,
      currentVideoThread: null,
      editCommentId: null,
      commentForDelete: null,
      openDeleteCommentModel: false,
    };
  },
  components: {
    FollowersDialog,
    LikesDialog,
    WeeklyTales,
    QrcodeVue,
    Biography,
    Photos,
    Documents,
    Videos,
    LastGreeting,
    NoResult,
  },
  computed: {
    documents() {
      return [
        {
          name: "Birth_Certificate.pdf",
          sizeInBytes: 12312312,
        },
        {
          name: "Baptism_Certificate_of_John_Doe.pdf",
          sizeInBytes: 31453,
        },
        {
          name: "High_School_Diploma.pdf",
          sizeInBytes: 322253,
        },
        {
          name: "University_Graduation_Certificate.pdf",
          sizeInBytes: 9625853,
        },
        {
          name: "Marriage_License_John_and_Jane_Doe.pdf",
          sizeInBytes: 21453,
        },
        {
          name: "Driver_License_John_Doe.pdf",
          sizeInBytes: 494453,
        },
        {
          name: "Passport_John_Doe.pdf",
          sizeInBytes: 3324453,
        },
        {
          name: "Military_Service_Record_John_Doe.pdf",
          sizeInBytes: 9494453,
        },
      ];
    },
    currentUser() {
      return JSON.parse(
        '{"id":"01H1F22K47ZPK57TYBHV76316666","name":"User1","lastName":"Usercic1","email":"user1@mailinator.com","gender":"Other","role":"Admin","dateOfBirth":"2021-05-04T00:00:00","phone":"063888888","country":"Srbija","city":"Nais","imageOriginalName":null,"imageName":null,"theme":"theme-black","notifications":{"imageComment":true,"videoComment":true,"followRequest":true,"lastGreeting":true,"imageVideoLike":false}}'
      );
    },
    personData() {
      return {
        id: "01HBV2F63YAVY21T6SQQFSTH38",
        userId: "01H1F22K47ZPK57TYBHV763166",
        subscriptionId: "123456789.jpg",
        activeUntil: "2042-06-16T10:53:17.2785369Z",
        nickname: "Vukica",
        dateOfBirth: "1952-11-16T10:53:17.2785369Z",
        dateOfDeath: "2023-05-16T10:53:17.2785369Z",
        gender: "Male",
        country: "United States",
        city: "New York",
        imageOriginalName: null,
        imageName: null,
        graveLocationCountry: "United States",
        graveLocationCity: "Los Angeles",
        graveLocationDescription: "Near the oak tree at the east end",
        graveLocationLat: 33.97111587017959,
        graveLocationLng: -118.3435898915387,
        zodiacSign: "Leo",
        eyeColor: "Blue",
        height: "183",
        weight: "95",
        packageDueDate: "2024-10-03T15:28:24.678Z",
        favorites: [
          { type: "FavoriteColor", value: "Blue" },
          { type: "FavoriteFood", value: "Spaghetti Bolognese" },
          { type: "FavoriteDesert", value: "Chocolate Cake" },
          { type: "FavoriteDrink", value: "Orange Juice" },
          { type: "FavoriteToy", value: "Lego" },
          { type: "FavoriteBreakfast", value: "Pancakes" },
          { type: "FavoriteLunch", value: "Grilled Chicken Salad" },
          { type: "FavoriteDinner", value: "Steak and Potatoes" },
          { type: "FavoriteSnacks", value: "Popcorn and Nachos" },
          { type: "FavoritePizza", value: "Pepperoni Pizza" },
          { type: "FavoritePasta", value: "Pesto Pasta" },
          { type: "FavoriteVegetable", value: "Broccoli" },
          { type: "FavoriteFruit", value: "Mango" },
          { type: "FavoriteMeat", value: "Lamb" },
          { type: "FavoriteCake", value: "Cheesecake" },
          { type: "FavoriteCoffee", value: "Latte" },
          { type: "FavoriteWine", value: "Red Wine" },
          { type: "FavoriteBeer", value: "Guinness" },
          { type: "FavoriteTea", value: "Green Tea" },
          { type: "FavoriteTravelPlace", value: "New York" },
          { type: "FavoriteMuseum", value: "The British Museum" },
          { type: "FavoriteWaterfall", value: "Niagara Falls" },
          { type: "FavoriteBeach", value: "Bondi Beach" },
          { type: "FavoriteLake", value: "Lake Tahoe" },
          { type: "FavoriteSea", value: "Mediterranean Sea" },
          { type: "FavoriteOcean", value: "Pacific Ocean" },
          { type: "FavoriteIsland", value: "Hawaii" },
          { type: "FavoriteMountain", value: "Mount Everest" },
          { type: "FavoriteRiver", value: "Amazon River" },
          { type: "FavoriteCity", value: "Tokyo" },
          { type: "FavoriteCountry", value: "Canada" },
          { type: "FavoriteMovie", value: "The Shawshank Redemption" },
          { type: "FavoriteMovieGenre", value: "Comedy" },
          { type: "FavoriteActor", value: "Robert Downey Jr." },
          { type: "FavoriteActress", value: "Emma Watson" },
          { type: "FavoriteTvShow", value: "Breaking Bad" },
          { type: "FavoriteCartoon", value: "SpongeBob SquarePants" },
          { type: "FavoriteMarvelMovie", value: "Iron Man" },
          { type: "FavoriteBand", value: "The Beatles" },
          { type: "FavoriteSong", value: "Bohemian Rhapsody" },
          { type: "FavoriteMusicGenre", value: "Rock" },
          { type: "FavoriteMaleSigner", value: "Ed Sheeran" },
          { type: "FavoriteFemaleSigner", value: "Adele" },
          { type: "FavoriteBook", value: "To Kill a Mockingbird" },
          { type: "FavoriteMaleWriter", value: "George Orwell" },
          { type: "FavoriteFemaleWriter", value: "Agatha Christie" },
          { type: "FavoriteSportPlayer", value: "Lionel Messi" },
          { type: "FavoriteSport", value: "Basketball" },
          { type: "FavoriteDance", value: "Tango" },
          { type: "FavoriteCar", value: "Tesla Model S" },
          { type: "FavoriteGame", value: "Minecraft" },
          { type: "FavoriteHobby", value: "Painting" },
          { type: "FavoriteFlower", value: "Rose" },
        ],
        occupation: "Software Engineer",
        name: null,
        passportId: null,
        chipId: null,
        species: null,
        breed: null,
        lastGreetings: [
          {
            byUserId: "01H1F3566ZCXJ0PPWTB3AW42XE",
            personId: "01HBV2F63YAVY21T6SQQFSTH38",
            note: "bas ces nam nedostajati...",
            id: "01HE5Q7DC4HHBBX4SXX346M0SD",
            createdAt: "2023-11-01T15:14:58.0528144Z",
            createdBy: null,
            modifiedAt: null,
            modifiedBy: null,
            reported: false,
          },
          {
            byUserId: "01H1F22K47ZPK57TYBHV763166",
            personId: "01HBV2F63YAVY21T6SQQFSTH38",
            note: "cao volelism ote v]biudi nam spokojan",
            id: "01HE69AZ8K3F88DYWSM30PQ2FH",
            createdAt: "2023-11-01T20:31:29.043721Z",
            createdBy: null,
            modifiedAt: null,
            modifiedBy: null,
            reported: false,
          },
          {
            byUserId: "01H1F22K47ZPK57TYBHV763166",
            personId: "01HBV2F63YAVY21T6SQQFSTH38",
            note: "dodao novi pa editovao pa edit opetdodao novi pa editovao pa edit opetdodao novi pa editovao pa edit opetdodao novi pa editovao pa edit opetdodao novi pa editovao pa edit opetdodao novi pa editovao pa edit opetdodao novi pa editovao pa edit opetdodao novi pa editovao pa edit opetdodao novi pa editovao pa edit opet",
            id: "01HJR9RSWD6G1RFD3C86ADKWGB",
            createdAt: "2023-12-28T13:28:09.357696Z",
            createdBy: "01H1F22K47ZPK57TYBHV763166",
            modifiedAt: "2024-01-12T21:12:06.8544626Z",
            modifiedBy: "01H1F22K47ZPK57TYBHV763166",
            reported: false,
          },
          {
            byUserId: "01H1F22K47ZPK57TYBHV763166",
            personId: "01HBV2F63YAVY21T6SQQFSTH38",
            note: "novi komentar",
            id: "01HTA3MEHC59PXG7H04ZWGC9NF",
            createdAt: "2024-03-31T11:17:07.756584Z",
            createdBy: "01H1F22K47ZPK57TYBHV763166",
            modifiedAt: "2024-03-31T11:18:03.0800102Z",
            modifiedBy: "01H1F22K47ZPK57TYBHV763166",
            reported: false,
          },
          {
            byUserId: "01H1F22K47ZPK57TYBHV763166",
            personId: "01HBV2F63YAVY21T6SQQFSTH38",
            note: "dasdas dasdas",
            id: "01HZYPJ3X1544X0YMBD62RNS1Y",
            createdAt: "2024-06-09T14:31:12.0332397Z",
            createdBy: "01H1F22K47ZPK57TYBHV763166",
            modifiedAt: "2024-06-09T14:33:58.9323391Z",
            modifiedBy: "01H1F22K47ZPK57TYBHV763166",
            reported: false,
          },
        ],
        images: DemoImages.Images(),
        videos: DemoVideos.Videos(),
        timelines: [
          {
            personId: "01HBV2F63YAVY21T6SQQFSTH38",
            userId: "01H1F22K47ZPK57TYBHV763166",
            from: "2024-09-02T00:00:00Z",
            to: null,
            title: "video",
            description: "video 2 sept",
            id: "01J75N0SV39WDW6A7XVQBSDDYN",
            createdAt: "2024-09-07T07:08:49.8911406Z",
            createdBy: null,
            modifiedAt: null,
            modifiedBy: null,
            reported: false,
          },
          {
            personId: "01HBV2F63YAVY21T6SQQFSTH38",
            userId: "01H1F22K47ZPK57TYBHV763166",
            from: "2024-08-31T00:00:00Z",
            to: null,
            title: "31 avg",
            description: "prvi treba da je u listi",
            id: "01J75N1C1BZZ38NF7QYQ4HR6NS",
            createdAt: "2024-09-07T07:09:08.5237172Z",
            createdBy: null,
            modifiedAt: null,
            modifiedBy: null,
            reported: false,
          },
          {
            personId: "01HBV2F63YAVY21T6SQQFSTH38",
            userId: "01H1F22K47ZPK57TYBHV763166",
            from: "2024-09-05T00:00:00Z",
            to: null,
            title: "SKOLA 1 SEPT",
            description: "posao djak prvak",
            id: "01J75N05RBHFPSHTJVW6EGPQPT",
            createdAt: "2024-09-07T07:08:29.3232928Z",
            createdBy: null,
            modifiedAt: null,
            modifiedBy: null,
            reported: false,
          },
          {
            personId: "01HBV2F63YAVY21T6SQQFSTH38",
            userId: "01H1F22K47ZPK57TYBHV763166",
            from: "2024-09-02T00:00:00Z",
            to: "2024-09-06T00:00:00Z",
            title: "2 - 4 sept",
            description: "2 do 4 sept",
            id: "01J75N242Y3Q511F9QPWM1FG3S",
            createdAt: "2024-09-07T07:09:33.151004Z",
            createdBy: null,
            modifiedAt: null,
            modifiedBy: null,
            reported: false,
          },
        ],
      };
    },
    personMetrics() {
      return {
        numberOfPictures: 33,
        numberOfVideos: 5,
        numberOfDocuments: 8,
        // "numberOfFollowers": 0,
        numberOfLastGreetings: 26,
        deceasedFullName: "John Doe",
        dateOfBirth: "1952-11-16T10:53:17.2785369Z",
        dateOfDeath: "2023-05-16T10:53:17.2785369Z",
        occupation: "Lawyer",
        isLoggedUserOwnerOrFollower: true,
        didLoggedUserSendFollowingInvitation: false,
        didLoggedUserReceiveFollowingInvitation: false,
        userMail: "",
        isHuman: true,
        nickname: "Justice John",
        userImageUrl: null,
        gender: "Male",
      };
    },
    currentPersonImage() {
      return this.personData.images[this.imageShowIndex];
    },
    currentPersonVideo() {
      return this.personData.videos[this.videoShowIndex];
    },
    currentPersonVideoUrl() {
      return this.currentPersonVideo?.videoUrl || "";
    },
    ...mapGetters("timeline", ["timelines", "timelinesLoading"]),
    ...mapGetters("lastGreeting", ["lastGreetingsLoading"]),
    petArray() {
      var arr = [
        "FavoriteFood",
        "FavoriteDesert",
        "FavoriteDrink",
        "FavoriteToy",
      ];
      return (
        this.personData?.favorites.filter((el) => arr.includes(el.type)) || []
      );
    },
    foodArray() {
      var arr = [
        "FavoriteBreakfast",
        "FavoriteLunch",
        "FavoriteDinner",
        "FavoriteSnacks",
        "FavoriteFood",
        "FavoriteMeat",
        "FavoritePizza",
        "FavoritePasta",
        "FavoriteVegetable",
        "FavoriteFruit",
        "FavoriteDessert",
        "FavoriteCake",
      ];
      return (
        this.personData?.favorites.filter((el) => arr.includes(el.type)) || []
      );
    },
    drinkArray() {
      var arr = [
        "FavoriteDrink",
        "FavoriteWine",
        "FavoriteBeer",
        "FavoriteTea",
        "FavoriteCoffee",
      ];
      return (
        this.personData?.favorites.filter((el) => arr.includes(el.type)) || []
      );
    },
    movieArray() {
      var arr = [
        "FavoriteMovie",
        "FavoriteMovieGenre",
        "FavoriteActor",
        "FavoriteActress",
        "FavoriteTvShow",
        "FavoriteCartoon",
        "FavoriteMarvelMovie",
      ];
      return (
        this.personData?.favorites.filter((el) => arr.includes(el.type)) || []
      );
    },
    booksArray() {
      var arr = ["FavoriteBook", "FavoriteMaleWriter", "FavoriteFemaleWriter"];
      return (
        this.personData?.favorites.filter((el) => arr.includes(el.type)) || []
      );
    },
    sportArray() {
      var arr = ["FavoriteSport", "FavoriteSportPlayer"];
      return (
        this.personData?.favorites.filter((el) => arr.includes(el.type)) || []
      );
    },
    lifestyleArray() {
      var arr = [
        "FavoriteDance",
        "FavoriteCar",
        "FavoriteGame",
        "FavoriteHobby",
        "FavoriteColor",
        "FavoriteFlower",
      ];
      return (
        this.personData?.favorites.filter((el) => arr.includes(el.type)) || []
      );
    },
    travelArray() {
      var arr = [
        "FavoriteTravelPlace",
        "FavoriteMuseum",
        "FavoriteWaterfall",
        "FavoriteBeach",
        "FavoriteLake",
        "FavoriteSea",
        "FavoriteOcean",
        "FavoriteIsland",
        "FavoriteMountain",
        "FavoriteRiver",
        "FavoriteCity",
        "FavoriteCountry",
      ];
      return (
        this.personData?.favorites.filter((el) => arr.includes(el.type)) || []
      );
    },
    musicArray() {
      var arr = [
        "FavoriteBand",
        "FavoriteSong",
        "FavoriteMusicGenre",
        "FavoriteMaleSigner",
        "FavoriteFemaleSigner",
      ];
      return (
        this.personData?.favorites.filter((el) => arr.includes(el.type)) || []
      );
    },
    people() {
      var toReturn = this.followerList.map((el) => {
        return {
          name: el.userFullName,
          group: "Group 1",
          avatar: el.originalImage,
        };
      });

      return toReturn;
    },
    qrCodeValue() {
      // Assuming your app is hosted at 'https://yourdomain.com'
      const baseUrl = "https://www.goodcasper.com";
      const route = this.$route.path;

      // Build the complete URL with route and parameters
      const completeUrl = `${baseUrl}${route}`;

      return completeUrl;
    },
    sharing() {
      return {
        url: this.shareableLink,
        title: "Good Casper",
        description: this.shareableDescription,
        quote: this.shareableQuote,
        hashtags:
          "GoodCasper,MemorialPlatform,RememberingLovedOnes,LifeTributes,DigitalLegacy,InLovingMemory,ForeverRemembered,HonoringMemories,MemorialProfiles,LifeStories,LegacyApp,DigitalRemembrance,PetMemorial,ForeverInOurHearts,RememberingPets,PetLegacy,GriefSupport,MemoriesMatter,LoveLivesOn,CherishTheMoments,ShareMemories,UploadMoments,MemorialThreads,KeepTheMemoryAlive,GlobalMemorialApp",
      };
    },
    lang() {
      return this.$store.state.langObj || {};
    },
    loadingBiographies() {
      return this.timelinesLoading;
    },
  },
  mounted() {
    document.title = "Good Casper - Demo Profile";
    this.scrollHandler = () => {
      const goTopButton = document.querySelector(".go-top");
      if (window.scrollY > 500) {
        goTopButton.classList.add("visible");
      } else {
        goTopButton.classList.remove("visible");
      }
    };

    window.addEventListener("scroll", this.scrollHandler);
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.scrollHandler);
  },
  methods: {
    initMap(lat, lng) {
      // Init map
      this.map = L.map("map", {
        scrollWheelZoom: false,
      }).setView([lat, lng], 13);
      L.tileLayer("https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png", {
        attribution:
          '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors',
      }).addTo(this.map);

      this.addMarker(lat, lng);
    },
    addMarker(lat, lng) {
      // If marker exists, remove it
      if (this.marker) {
        this.map.removeLayer(this.marker);
      }

      // Create new marker
      const googleMapsUrl = `https://www.google.com/maps?q=${lat},${lng}`;
      this.marker = L.marker([lat, lng]).on("click", () => {
        window.open(googleMapsUrl, "_blank"); // Open Google Maps in new tab
      });

      // Add popup with Google Maps link
      this.marker.bindPopup(`
        <div>
          <a href="${googleMapsUrl}" target="_blank" style="color: blue; text-decoration: underline;">
            Google Maps
          </a>
        </div>
      `);

      // Add marker on map
      this.marker.addTo(this.map);
      this.map.setView([lat, lng], 13);
    },
    setBrowserTheme(color = false) {
      if (!color) {
        var theme = window.localStorage.getItem("theme");

        var color = "#3093a5";
        switch (theme || "no-theme") {
          case "no-theme":
          case "theme-default":
            color = "#3093a5";
            break;
          case "theme-black":
            color = "#000000";
            break;
          case "theme-blue-gray":
            color = "#607D8B";
            break;
          case "theme-blue":
            color = "#1E88E5";
            break;
          case "theme-cyan":
            color = "#00B8D4";
            break;
          case "theme-dark-red":
            color = "#D50000";
            break;
          case "theme-green":
            color = "#64DD17";
            break;
          case "theme-light-green":
            color = "#00C853";
            break;
          case "theme-light-brown":
            color = "#8D6E63";
            break;
          case "theme-lime-dark":
            color = "#9E9D24";
            break;
          case "theme-orange":
            color = "#F57C00";
            break;
          case "theme-pink":
            color = "#FF4081";
            break;
          case "theme-light-purple":
            color = "#E040FB";
            break;
          case "theme-purple":
            color = "#800080";
            break;
        }

        document
          .querySelector('meta[name="theme-color"]')
          ?.setAttribute("content", color);
      } else {
        document
          .querySelector('meta[name="theme-color"]')
          ?.setAttribute("content", color);
      }
    },
    showComments() {
      this.showComment = !this.showComment;
    },
    downloadFileDemo() {
      this.notAllowedInDemoMode = true;
    },
    goToTop() {
      window.scrollTo({ top: 0, behavior: "smooth" });
    },
    triggerFileUpload() {
      this.notAllowedInDemoMode = true;
    },
    goTo(page) {
      if (page == "/") {
        this.$router.push(page);
      } else {
        this.$router.push(`/Login?state=${page}`);
      }
    },
    closeNotAllowedInDemoMode() {
      this.notAllowedInDemoMode = false;
      this.dialogInvite = false;
    },
    getUserProfileImage(gender) {
      return helpers.getAvatarProfile(gender, true);
    },
    closeDialogFollowPerson() {
      this.description = "";
      this.dialogFollow = false;
    },
    sendRequestModal() {
      this.dialogFollow = true;
    },
    followPerson() {
      this.notAllowedInDemoMode = true;
      this.closeDialogFollowPerson();
    },
    seePendingRequest() {
      this.$router.push("/PendingRequests");
    },
    closeFollowerList() {
      this.dialogFollowers = false;
    },
    isTypeOf(data) {
      return typeof data.item !== "object";
    },
    saveInfoDialog() {
      this.notAllowedInDemoMode = true;
    },
    editInfo(item, type) {
      this.info = {
        location: item.location,
        title: item.title,
        description: item.description,
        memoryDate: item.memoryDate
          ? moment(item.memoryDate).format("YYYY-MM-DD")
          : null,
        friends: item.friends,
      };
      if (type == "video") {
        this.info.videoId = item.id;
      } else {
        this.info.imageId = item.id;
      }

      this.showInfoEdit = true;
    },
    remove(item) {
      const index = this.info.friends.indexOf(item.name);
      if (index >= 0) this.info.friends.splice(index, 1);
    },
    showInfoContainer() {
      this.showInfo = true;
    },
    closeInfoDialog() {
      this.showInfoEdit = false;
      this.showInfo = false;
    },
    closeEditInfoDialog() {
      this.showInfoEdit = false;
    },
    deleteComment() {
      this.notAllowedInDemoMode = true;
    },
    closeDeleteCommentModel() {
      this.commentForDelete = null;
      this.openDeleteCommentModel = false;
    },
    deleteCommentDialog(comment, type, state) {
      this.commentForDelete = comment;
      this.commentForDelete.type = type;
      this.commentForDelete.state = state;
      this.openDeleteCommentModel = true;
    },
    closeEditComment() {
      this.editCommentId = null;
      this.imageComment = "";
      this.videoComment = "";
      this.imageCommentThread = "";
      this.videoCommentThread = "";
    },
    editComment(comment) {
      this.imageComment = comment.text;
      this.videoComment = comment.text;
      this.imageCommentThread = comment.text;
      this.videoCommentThread = comment.text;
      this.editCommentId = comment.id;
    },
    closeImageDialog() {
      this.dialog = false;
      this.closeInfoDetailsOverlay();
      this.resetDialogState();
      this.$router.push({ query: {} });
    },
    resetDialogState() {
      this.editCommentId = null;
      this.threadList = null;
      this.imageComment = "";
      this.imageCommentThread = "";
      this.videoComment = "";
      this.videoCommentThread = "";
      this.setBrowserTheme();
    },
    closeVideoDialog() {
      this.dialogVideo = false;
      this.closeInfoDetailsOverlay();
      this.resetDialogState();
      this.$router.push({ query: {} });
    },
    getUserInitials(name, lastName) {
      return helpers.getInitials(name, lastName);
    },
    getFullNameInitials(name) {
      return helpers.getFullNameInitials(name);
    },
    seeThreadsOverlay(threads) {
      this.threadList = threads;
    },
    closeThreadOverlay() {
      this.threadList = null;
    },
    closeInfoDetailsOverlay() {
      this.showInfo = null;
      this.showInfoEdit = null;
    },
    viewLikes(likes) {
      this.likeList = [
        {
          name: "John",
          lastName: "Doe",
          imageUrl: require(`../../assets/images/profiles/profile-man-1-min.jpg`),
          fullName: "John Doe",
        },
        {
          name: "Jane",
          lastName: "Smith",
          imageUrl: require(`../../assets/images/profiles/profile-woman-2-min.jpg`),
          fullName: "Jane Smith",
        },
        {
          name: "Alice",
          lastName: "Johnson",
          imageUrl: require(`../../assets/images/profiles/profile-woman-3-min.jpg`),
          fullName: "Alice Johnson",
        },
        {
          name: "Robert",
          lastName: "Brown",
          imageUrl: null,
          fullName: "Robert Brown",
        },
        {
          name: "Emily",
          lastName: "Davis",
          imageUrl: null,
          fullName: "Emily Davis",
        },
        {
          name: "Michael",
          lastName: "Wilson",
          imageUrl: require(`../../assets/images/profiles/profile-man-3-min.jpg`),
          fullName: "Michael Wilson",
        },
        {
          name: "Sarah",
          lastName: "Miller",
          imageUrl: null,
          fullName: "Sarah Miller",
        },
        {
          name: "David",
          lastName: "Moore",
          imageUrl: require(`../../assets/images/profiles/profile-man-11-min.jpg`),
          fullName: "David Moore",
        },
        {
          name: "Laura",
          lastName: "Taylor",
          imageUrl: require(`../../assets/images/profiles/profile-woman-6-min.jpg`),
          fullName: "Laura Taylor",
        },
        {
          name: "James",
          lastName: "Anderson",
          imageUrl: require(`../../assets/images/profiles/profile-man-7-min.jpg`),
          fullName: "James Anderson",
        },
        {
          name: "Linda",
          lastName: "Thomas",
          imageUrl: require(`../../assets/images/profiles/profile-woman-8-min.jpg`),
          fullName: "Linda Thomas",
        },
        {
          name: "Chris",
          lastName: "Martin",
          imageUrl: require(`../../assets/images/profiles/profile-man-9-min.jpg`),
          fullName: "Chris Martin",
        },
        {
          name: "Jessica",
          lastName: "Lee",
          imageUrl: null,
          fullName: "Jessica Lee",
        },
        {
          name: "Daniel",
          lastName: "Harris",
          imageUrl: require(`../../assets/images/profiles/profile-man-10-min.jpg`),
          fullName: "Daniel Harris",
        },
        {
          name: "Sophia",
          lastName: "Clark",
          imageUrl: null,
          fullName: "Sophia Clark",
        },
        {
          name: "Matthew",
          lastName: "Lewis",
          imageUrl: null,
          fullName: "Matthew Lewis",
        },
        {
          name: "Olivia",
          lastName: "Walker",
          imageUrl: require(`../../assets/images/profiles/profile-woman-11-min.jpg`),
          fullName: "Olivia Walker",
        },
        {
          name: "Joshua",
          lastName: "Hall",
          imageUrl: require(`../../assets/images/profiles/profile-man-13-min.jpg`),
          fullName: "Joshua Hall",
        },
        {
          name: "Isabella",
          lastName: "Young",
          imageUrl: null,
          fullName: "Isabella Young",
        },
        {
          name: "Andrew",
          lastName: "King",
          imageUrl: null,
          fullName: "Andrew King",
        },
        {
          name: "Mia",
          lastName: "Wright",
          imageUrl: require(`../../assets/images/profiles/profile-woman-5-min.jpg`),
          fullName: "Mia Wright",
        },
        {
          name: "Ethan",
          lastName: "Scott",
          imageUrl: require(`../../assets/images/profiles/profile-man-6-min.jpg`),
          fullName: "Ethan Scott",
        },
        {
          name: "Ava",
          lastName: "Green",
          imageUrl: null,
          fullName: "Ava Green",
        },
        {
          name: "Alexander",
          lastName: "Adams",
          imageUrl: require(`../../assets/images/profiles/profile-man-4-min.jpg`),
          fullName: "Alexander Adams",
        },
        {
          name: "Charlotte",
          lastName: "Baker",
          imageUrl: null,
          fullName: "Charlotte Baker",
        },
        {
          name: "William",
          lastName: "Nelson",
          imageUrl: require(`../../assets/images/profiles/profile-man-5-min.jpg`),
          fullName: "William Nelson",
        },
      ].slice(0, likes);
    },
    closeLikeList() {
      this.likeList = [];
    },
    entityLiked(likes) {
      return []; // likes.find((el) => el.userId == this.currentUser.id)?.id || false;
    },
    shareContent(data, type) {
      const currentRoute = this.$route.path;
      var typeValue = 0;
      switch (type) {
        case "image":
          typeValue = 1;
          break;
        case "video":
          typeValue = 2;
          break;
        case "profile":
          typeValue = 0;
          break;
        default:
          break;
      }
      const currentParams = `id=${data.id}&type=${typeValue}`;

      this.shareableLink = this.createShareableLink(
        currentRoute,
        typeValue ? currentParams : ""
      );

      this.shareableDescription = "Demo profile";
      this.shareableQuote = "Demo profile";

      // Set the generated link in the component data
      this.showShareSocialActionsPopup = true;
    },
    createShareableLink(route, params) {
      const baseUrl = "https://www.goodcasper.com";

      // Ensure route starts with a slash
      const sanitizedRoute = route.startsWith("/") ? route : `/${route}`;

      // Handle params as either a string or an object
      const paramString =
        typeof params === "string"
          ? params
          : new URLSearchParams(params || {}).toString();

      // Construct the final URL
      const completeUrl = paramString
        ? `${baseUrl}${sanitizedRoute}?${paramString}`
        : `${baseUrl}${sanitizedRoute}`;

      return completeUrl;
    },
    manageLike(type, data, id, onWhat, isThread) {
      this.notAllowedInDemoMode = true;
    },
    manageBookmark() {
      this.notAllowedInDemoMode = true;
    },
    addInviteMails() {
      if (this.inviteEmail.match(/\S+@\S+\.\S+/)) {
        this.inviteEmails.push(this.inviteEmail);
      }
      this.inviteEmail = "";
    },
    leaveCommentThreadOnImage() {
      this.notAllowedInDemoMode = true;
    },
    leaveCommentThreadOnVideo() {
      this.notAllowedInDemoMode = true;
    },
    leaveCommentOnImage() {
      this.notAllowedInDemoMode = true;
    },
    leaveCommentOnVideo() {
      this.notAllowedInDemoMode = true;
    },
    deleteImage() {
      this.notAllowedInDemoMode = true;
    },
    deleteVideo() {
      this.notAllowedInDemoMode = true;
    },
    leftImage() {
      this.closeThreadOverlay();
      this.imageShowIndex = this.imageShowIndex - 1;
      this.closeInfoDetailsOverlay();
      this.emitImageShow(this.imageShowIndex);
    },
    leftVideo() {
      this.closeThreadOverlay();
      this.videoShowIndex = this.videoShowIndex - 1;
      this.closeInfoDetailsOverlay();
      this.emitVideoShow(this.videoShowIndex);
    },
    rightImage() {
      this.closeThreadOverlay();
      this.imageShowIndex = this.imageShowIndex + 1;
      this.closeInfoDetailsOverlay();
      this.emitImageShow(this.imageShowIndex);
    },
    rightVideo() {
      this.closeThreadOverlay();
      this.videoShowIndex = this.videoShowIndex + 1;
      this.closeInfoDetailsOverlay();
      this.emitVideoShow(this.videoShowIndex);
    },
    emitImageShow(index) {
      this.closeThreadOverlay();
      this.imageShowIndex = index;
      this.dialog = true;
      this.personData.images[this.imageShowIndex] = this.currentPersonImage;
      this.setBrowserTheme("#1c1e21");
    },
    emitVideoShow(index) {
      this.closeThreadOverlay();
      this.videoShowIndex = index;
      this.dialogVideo = true;
      this.personData.videos[this.videoShowIndex] = this.currentPersonVideo;
      this.setBrowserTheme("#1c1e21");
    },
    showFollowers() {
      this.dialogFollowers = true;
    },
    deleteLastGreetingModal() {
      this.notAllowedInDemoMode = true;
    },
    addLastGreetingModal() {
      this.notAllowedInDemoMode = true;
    },
    deleteLastGreeting() {
      this.notAllowedInDemoMode = true;
    },
    addLastGreeting() {
      this.notAllowedInDemoMode = true;
      this.lastGreetingModel = false;
    },
    updateProfile() {
      this.notAllowedInDemoMode = true;
    },
    saveDateOfBirthMenu(date) {
      this.$refs.dateOfBirthMenu.save(date);
    },
    saveInfoDateMenu(date) {
      this.$refs.dateOfEvent.save(date);
    },
    saveDateOfDeathMenu(date) {
      this.$refs.dateOfDeathMenu.save(date);
    },
    setEditMode(mode) {
      this.editMode = mode;
      if (mode) {
        this.personData.dateOfBirth = moment(
          this.personData.dateOfBirth
        ).format("YYYY-MM-DD");
        this.personData.dateOfDeath = moment(
          this.personData.dateOfDeath
        ).format("YYYY-MM-DD");
        this.personDataClone = { ...this.personData };
      }
    },
    cancelEditMode() {
      this.$store.state.person.personData = { ...this.personDataClone };
      this.setEditMode(false);
    },
    closeDialogInvite() {
      this.dialogInvite = false;
      this.inviteEmail = "";
      this.inviteEmails = [];
    },
    inviteUser() {
      this.notAllowedInDemoMode = true;
      this.closeDialogInvite();
    },
    getBirthToDeathDate(birthDate, deathDate) {
      return `${moment(birthDate).format("DD/MM/YYYY")} - ${moment(
        deathDate
      ).format("DD/MM/YYYY")}`;
    },
    getDate(date) {
      return moment(new Date(date)).format("lll");
    },
    getDateShort(date) {
      return moment(new Date(date)).format("MMM Do") || "-";
    },
    getPersonAge(birthDate, deathDate) {
      const dateOfBirth = moment(birthDate);
      const dateOfDeath = moment(deathDate);

      const age = dateOfDeath.diff(dateOfBirth, "years");

      return age;
    },
    addTimeline(bio) {
      delete bio.id;
      bio.from = bio.from ? new Date(`${bio.from}`).toISOString() : null;
      bio.to = bio.to ? new Date(`${bio.to}`).toISOString() : null;
      bio.personId = this.$route.params.id;
      bio.dateOfCreate = new Date();
      bio.currentUser = this.currentUser.id;
      this.$store.dispatch("timeline/addTimeline", bio).then(() => {
        this.getTimelines();
      });
    },
    editTimeline() {
      this.notAllowedInDemoMode = true;
    },
    deleteTimeline(bioId) {
      this.notAllowedInDemoMode = true;
    },
    getPersonImageById(entityId) {
      this.$store.dispatch("images/getPersonImageById", {
        personId: this.$route.params.id,
        entityId,
      });
    },
  },
  watch: {
    togglePanel(val) {
      if (val) {
        setTimeout(() => {
          this.initMap(
            this.personData.graveLocationLat,
            this.personData.graveLocationLng
          );
        }, 300);
      }
    },
    tabSelected(val) {
      if (!this.personMetrics.isLoggedUserOwnerOrFollower) {
        return;
      }
    },
    fBirthMenu(val) {
      val &&
        setTimeout(() => {
          this.activePickerBirth = "YEAR";
        }, 500);
    },
    dateOfDeathMenu(val) {
      val &&
        setTimeout(() => {
          this.activePickerDeath = "YEAR";
        }, 500);
    },
    infoDateMenu(val) {
      val &&
        setTimeout(() => {
          this.activePickerInfo = "YEAR";
        }, 500);
    },
  },
};
</script>
  
<style lang="scss">
.wrapper {
  .row {
    margin-left: 0;
    margin-right: 0;
  }
}
@media (max-width: 600px) {
  .wrapper {
    .row {
      margin-top: 0 !important;
    }
    .mt-5 {
      margin-top: 20px !important;
      padding-top: 0 !important;
    }
  }
}
.leave-demo-mode {
  position: fixed;
  bottom: 20px;
  left: 20px;
  padding: 10px;
  box-shadow: 0px 0px 10px 0px rgb(0 0 0 / 10%);
  border-radius: 50%;
  // width: 70px;
  aspect-ratio: 1/1;
  color: #fff;
  background: #000;
  z-index: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
}
.v-expansion-panel-content__wrap {
  @media (max-width: 600px) {
    padding: 0 !important;
  }
}
.v-file-input.v-text-field--filled:not(.v-text-field--single-line)
  .v-file-input__text {
  padding-top: 0;
}

.v-slide-group:not(.v-slide-group--has-affixes) > .v-slide-group__prev,
.v-slide-group:not(.v-slide-group--has-affixes) > .v-slide-group__next {
  display: none !important;
}
.v-text-field.v-text-field--solo:not(.v-text-field--solo-flat)
  > .v-input__control
  > .v-input__slot {
  box-shadow: none;
  background: rgba(0, 0, 0, 0.06) !important;
}
// .v-window {
//   background: red!important;
// }
</style>
<style lang="scss" scoped>
.text-shadow {
  text-shadow: 0px 0px 3px rgba(0, 0, 0, 0.5);
}
.my-comment.input-group {
  display: flex;
  flex-direction: row;
  gap: 0rem;
}

.my-comment.input-group label {
  font-size: 0.875rem;
  font-weight: 500;
  color: #4a5568;
}

.my-comment.input-group input {
  padding: 0.625rem;
  border: 1px solid #e2e8f0;
  border-radius: 6px;
  font-size: 0.875rem;
  transition: all 0.2s ease;
  background-color: #f8fafc;
  color: #334155;
  @media screen and (max-width: 768px) {
    padding: 0.5rem;
  }
}

.my-comment.input-group input::placeholder {
  color: #94a3b8;
}

.my-comment.input-group input:focus {
  outline: none;
  box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1);
  background-color: #fff;
}

.my-comment.input-group textarea {
  padding: 0.625rem;
  border: 1px solid #e2e8f0;
  border-radius: 6px;
  font-size: 0.875rem;
  transition: all 0.2s ease;
  background-color: #f8fafc;
  color: #334155;
  width: 100%;
  resize: none; /* Disable resizing */
  overflow: auto; /* Ensure scrollbars appear if needed */
}

.my-comment.input-group textarea::placeholder {
  color: #94a3b8;
}

.my-comment.input-group textarea:focus {
  outline: none;
  box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1);
  background-color: #fff;
}

@media screen and (max-width: 768px) {
  .my-comment.input-group textarea {
    padding: 0.5rem;
  }
}
/* Dodaj malo prostora između polja i karte */
.v-text-field {
  margin-bottom: 16px;
}
#map {
  border: 1px solid #ddd;
}
.no-gutters.mt-0.row {
  margin-top: 0 !important;
}
.show-mobile {
  display: none;
}

@media (max-width: 600px) {
  .show-mobile {
    display: block;
  }
  .comment-container {
    display: none;
    &.show {
      display: block;
    }
  }
  .comments {
    position: fixed;
    inset: 0;
    top: 0;
    bottom: 140px;
    z-index: 6;
    &.pt-6 {
      padding-top: 35px !important;
    }
  }
  .comment-x {
    position: fixed;
    top: 0;
    right: 0;
    background: transparent;
    display: flex;
    justify-content: flex-end;
    z-index: 999;
    * {
      cursor: pointer;
      padding: 5px 10px;
    }
  }
}

.go-back {
  cursor: pointer;
  border: 1px solid #ccc;
  // box-shadow: 0px 0px 0px 1px rgb(0 0 0 / 10%);
  padding-left: 10px;
  padding-right: 10px;
  border-radius: 2px;
  margin-right: 10px;
}
.image-checked {
  background: rgba(0, 0, 0, 0.5);
  border-radius: 4px;
  border: 1px solid #fff;
  position: absolute;
  bottom: 5px;
  left: 15px;
  z-index: 99;
  color: #fff;
}
.click-to-select {
  cursor: pointer;
  background: rgba(0, 0, 0, 0.5);
  // border-radius: 4px;
  // border: 1px solid #fff;
  position: absolute;
  bottom: 0px;
  left: 11px;
  z-index: 99;
  color: #fff;
  padding: 8px 8px;
  display: block;
  width: calc(100% - 11px);
  // width: 100%;
  text-align: center;
}
.suggestions-count {
  cursor: pointer;
  background: red;
  color: #fff;
  font-size: 8px;
  border-radius: 50%;
  width: 15px;
  aspect-ratio: 1;
  position: absolute;
  top: 6px;
  left: 35px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.suggested-container {
  cursor: pointer;
  box-shadow: 0px 0px 0px 1px rgb(0 0 0 / 10%);
  padding: 10px 0 10px 5px;
  border-radius: 8px;
  background: #fff;
  display: flex;
  .suggested-content {
    p {
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      width: 100%;
    }
  }
  > div {
    display: flex;
    justify-content: center;
    align-items: center;
    * {
      margin-bottom: 0;
    }
  }
  > div:nth-child(1) {
    width: 55px;
    justify-content: flex-start;
  }
  > div:nth-child(2) {
    // width: calc(100% - 235px);
    width: calc(100% - 165px);
    flex-direction: column;
    align-items: flex-start;
  }
  > div:nth-child(3) {
    width: 70px;
    flex-direction: column;
    align-items: flex-end;
    padding-right: 10px;
  }
  // > div:nth-child(4) {
  //   width: 70px;
  //   flex-direction: column;
  //   align-items: flex-end;
  //   padding-right: 10px;
  //   box-sizing: border-box;
  // }
  // > div:nth-child(5) {
  //   width: 40px;
  //   flex-direction: column;
  //   align-items: center;
  //   justify-content: center;
  //   border-left: 1px solid #ccc;
  // }
  > div:nth-child(4) {
    width: 40px;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    border-left: 1px solid #ccc;
  }
}
.upload-files-container {
  margin: auto;
  border: 2px dotted #ccc;
  text-align: center;
  border-radius: 12px;
  height: 75vh;
  display: flex;
  justify-content: center;
  align-items: center;
  .file-uploads {
    width: 100%;
    height: 100%;
    padding-top: 80px;
    padding-bottom: 80px;
  }
  img {
    width: 200px;
  }
  * {
    cursor: pointer;
  }
}
.go-top {
  position: fixed;
  bottom: 20px;
  right: 20px;
  padding: 10px;
  border-radius: 50%;
  z-index: 9;
  background: #000;
  cursor: pointer;
  display: none;
  &.visible {
    display: block;
  }
  i {
    color: #fff;
  }
  @media screen and (max-width: 600px) {
    bottom: 20px;
  }
}
.no-shadow {
  box-shadow: none !important;
}
.info-title {
  color: #636363;
}
.info-text {
  color: #636363;
}
.show-info-relative {
  position: relative;
  .show-info-container {
    position: absolute;
    top: 50px;
    right: 0;
    min-width: 350px;
    height: auto;
    // overflow-y: auto;
    border-radius: 4px;
    background: #fff;
    z-index: 50;
    .edit-dialog-info {
      position: absolute;
      top: 5px;
      left: 5px;
      color: #000;
      padding: 15px;
      cursor: pointer;
    }
    .close-dialog-info {
      position: absolute;
      top: 5px;
      right: 5px;
      color: #000;
      padding: 15px;
      cursor: pointer;
      text-shadow: 0px 0px 3px rgba(0, 0, 0, 0.5);
    }
  }
}
.share-social-container {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  padding: 15px 0;
  a {
    padding: 3px 10px;
    margin: 5px;
    text-decoration: none;
    color: #fff;
    border-radius: 8px;
    i {
      color: #fff;
    }
  }
}
.main-comment {
  background: #f6f6f6;
  width: 100%;
  padding: 12px 5px 0px 0px;
  border-radius: 8px;
  margin-bottom: 15px;
}
.v-window-item--active {
  min-height: 80vh;
}
.v-expansion-panel::before {
  box-shadow: 0px 0px 0px 1px rgb(0 0 0 / 10%);
}
.image-container {
  position: relative;
  background: #1c1e21;
  min-height: calc(100vh - 3px);
  display: flex;
  justify-content: center;
  align-items: center;
  .v-image,
  img,
  video {
    max-width: 100vw;
    max-height: calc(100vh - 10px);
    margin: auto auto;
  }
  .action-dialog {
    position: absolute;
    top: 0;
    right: 0;
    color: #fff;
    padding: 15px;
    z-index: 5;
    button {
      text-shadow: 0px 0px 3px rgba(0, 0, 0, 0.5);
    }
  }
  .close-dialog {
    position: absolute;
    top: 0;
    left: 0;
    color: #fff;
    padding: 15px;
    text-shadow: 0px 0px 3px rgba(0, 0, 0, 0.5);
    &:hover {
      background: rgb(27 27 27 / 80%);
    }
  }
  .next-image {
    position: absolute;
    top: 49%;
    right: 8px;
    z-index: 5;
    color: #fff;
    padding: 15px 15px;
    text-shadow: 0px 0px 3px rgba(0, 0, 0, 0.5);
    &:hover {
      background: rgb(27 27 27 / 80%);
    }
    &::after {
      background: transparent !important;
    }
  }
  .back-image {
    position: absolute;
    top: 49%;
    left: 0;
    z-index: 5;
    color: #fff;
    padding: 15px 15px;
    text-shadow: 0px 0px 3px rgba(0, 0, 0, 0.5);
    &:hover {
      background: rgb(27 27 27 / 80%);
    }
    &::after {
      background: transparent !important;
    }
  }
}
.comment-container {
  background: #fff;
  min-height: calc(100vh - 64px);
  position: relative;
  padding-left: 10px;
  padding-right: 10px;
  .comment-item {
    border-bottom: 1px solid rgb(236, 236, 236);
    padding-bottom: 2px;
    &:last-child {
      border-bottom: none;
    }
  }
  .comments {
    padding-top: 12px;
    max-height: calc(100vh - 140px);
    background: #fff;
    overflow-y: scroll;
    .v-avatar {
      align-self: flex-start;
    }
    p {
      font-size: 12px;
      margin-bottom: 12px;
      color: #636363;
    }
    .caption-1 {
      font-size: 10px !important;
      color: #868686;
    }
  }
  .my-comment {
    flex: 0 0 24.5%;
    max-width: 24.5%;
    width: 100%;
    box-sizing: border-box;
    position: fixed;
    background: #fff;
    padding-top: 12px;
    padding-bottom: 12px;
    // border-top: 1px solid #ccc;
    bottom: 0;
    width: 100%;
    .v-text-field__details {
      display: none;
    }
    // .v-avatar {
    //   align-self: flex-end;
    // }
    // box-shadow: 0 0 4px 1px rgb(177, 177, 177);
  }
}
.edit-pen {
  cursor: pointer;
  position: absolute;
  right: 20px;
}
.qr-code {
  cursor: pointer;
  position: absolute;
  left: 20px;
  top: 60px;
}
.share-social-profile {
  cursor: pointer;
  position: absolute;
  left: 20px;
}
.report-pen {
  cursor: pointer;
  position: absolute;
  right: 20px;
  color: #b4b4b4;
  &:hover {
    color: #b71c1c;
  }
}
.v-sheet.v-card:not(.v-sheet--outlined) {
  height: 100%;
}
.rel {
  position: relative;
  width: 180px;
  .input-image-container {
    border-width: 5px;
    border-style: solid;
    position: absolute;
    inset: 0px;
    border-radius: 50%;
    display: flex;
    width: 180px;
    height: 180px;
    background: transparent;
    justify-content: center;
    overflow: hidden;
    cursor: pointer;
    .camera-container {
      position: absolute;
      display: flex;
      justify-content: center;
      align-items: flex-start;
      padding-top: 6px;
      background-color: rgba(0, 0, 0, 0.5);
      width: 170px;
      height: 90px;
      position: absolute;
      bottom: -55px;
      border-bottom-left-radius: 90px; /* 50% of parent width */
      border-bottom-right-radius: 90px; /* 50% of parent width */
      * {
        color: #fff;
      }
    }
  }
  .v-input {
    flex: 0 0 100%;
    margin: 0;
    padding: 5px;
  }
}
.user-profile-image {
  width: 150px;
  border-radius: 50%;
}
.column-center {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.profile-stats {
  flex-wrap: wrap;
  display: flex;
  justify-content: flex-end;
  section {
    width: 100%;
  }
  > div {
    flex: 0 0 25%;
    width: 25%;
    &.full-width {
      width: 100%;
      flex: 0 0 100%;
      > .with-radius {
        width: 180px;
      }
    }
    .v-divider {
      width: 50%;
      margin: auto;
    }
  }
  .full-row {
    flex: 0 0 100%;
  }
  &.edit-mode {
    > div {
      flex: 0 0 33.33%;
      width: 33.33%;
    }
    .full-row {
      flex: 0 0 100%;
    }
  }
  > div.action-form {
    flex: 0 0 100%;
    width: 100%;
    margin-top: 10px;
  }
  p {
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
    font-size: 14px;
    color: #636363;
    font-weight: 600;
  }
  span.overline {
    color: #c1bfbf;
    font-size: 10px !important;
  }
  &--user {
    justify-content: space-evenly;
    margin-top: 25px;
    width: 100%;
    > div {
      flex: 0 0 33.33%;
      width: 33.33%;
    }
    .display-1 {
      font-size: 22px !important;
    }
    span.overline {
      margin-top: -10px;
      display: block;
    }
  }
}

@media only screen and (max-width: 1050px) {
  .profile-stats {
    justify-content: center;
    > div {
      flex: 0 0 33.33%;
      width: 33.33%;
      .v-divider {
        width: 70%;
        margin: auto;
      }
    }
    p {
      font-size: 16px;
    }
    span.overline {
      font-size: 10px !important;
    }
    &--user {
      margin-top: 25px;
      > div {
        flex: 0 0 33.33%;
        width: 33.33%;
      }
      .display-1 {
        font-size: 22px !important;
      }
      span.overline {
        margin-top: -10px;
      }
    }
  }
}
@media only screen and (max-width: 960px) {
  .image-container {
    .v-image,
    img,
    video {
      max-width: 100vw;
      max-height: 100vh;
      margin: auto auto;
      // max-width: 100%;
      // max-height: 100vh;
    }
  }
  .comment-container {
    .my-comment {
      flex: 0 0 100%;
      max-width: 100%;
      bottom: 1px;
    }
  }
}
@media only screen and (max-width: 750px) {
  .profile-stats {
    justify-content: center;
    > div {
      flex: 0 0 50%;
      width: 50%;
      .v-divider {
        width: 80%;
        margin: auto;
      }
    }
    p {
      font-size: 13px;
    }
    span.overline {
      font-size: 9px !important;
    }

    &--user {
      margin-top: 25px;
      > div {
        flex: 0 0 33.33%;
        width: 33.33%;
      }
      .display-1 {
        font-size: 18px !important;
      }
      span.overline {
        margin-top: -10px;
      }
    }
    &.edit-mode {
      margin-top: 25px;
      > div {
        flex: 0 0 100% !important;
        width: 100% !important;
      }
      .display-1 {
        font-size: 18px !important;
      }
      span.overline {
        margin-top: -10px;
      }
    }
  }
}

@media only screen and (max-width: 600px) {
  .no-padding-mobile {
    > .col-12 {
      padding-left: 0 !important;
      padding-right: 0 !important;
    }
  }
}
</style>